<template>
  <div :class="['order-wrap', 'clearfix', { 'order-wrap-min': !isSubmit }]">
    <Spin size="large" fix v-if="isLoading"></Spin>
    <template v-for="(item, index) in otherComponents">
      <template v-if="item.type === 'cd-webSettlement'">
        <div class="order-content" :key="index" v-show="!isSubmit">
          <!-- 餐品信息-->
          <div class="order-products">
            <!-- 点餐单 - start -->
            <div class="order-foods-box">
              <!-- 餐品列表 - start -->
              <div class="order-foods-ls">
                <div class="title">
                  <h3 class="flag"><!-- 餐品信息 -->{{ $t('food.info') }}</h3>
                  <!-- 返回外卖篮子修改 -->
                  <!-- <span class="bg-main fc-main" @click.stop="backToBooking" sub><i>&lt;</i>{{'继续购物'}}</span> -->
                </div>
                <ul class="orders-tab">
                  <li style="width:160px;"><!-- 餐品 -->{{ $t('food.name')}}</li>
                  <li style="width:90px;text-align: center;"><!-- 份数 -->{{ $t('orders.count[0]') }}</li>
                  <!-- <li style="width:92px;">份数{{份数'}}</li> -->
                  <li style="width:67px;text-align: center;"><!-- 原价 -->{{ $t('orders.prices[0]') }}</li>
                  <li style="width:75px;text-align: center;"><!-- 现价 -->{{ $t('orders.prices[1]') }}</li>
                  <li style="width:82px;text-align: center;"><!-- 小计 -->{{ $t('orders.prices[2]') }}</li>
                  <!-- 积分兑换 -->
                  <!-- <li style="width:80px;text-align: center;">{{ $t('header.user.exchange') }}</li> -->
                </ul>

                <div class="order-list">
                  <table v-for="(good, index) in goods" :key="index" class="tb-orders-el">
                    <tbody>
                      <tr>
                        <template v-if="good.type === 2">
                          <group-info :product="foods[index].pid === good.uid && foods[index]" class="group-info">
                            <td slot="title" width="160" class="text-left">
                              {{ $i18n.locale === 'zh' ? good.name : (good.nameEn || good.name) }}
                            </td>
                            <td width="90">
                              <cart-control
                                :food="good"
                                :index="index"
                                :site="'cart'"
                                @ADD_TO_CART="ADD_TO_CART"
                                class="item-change"></cart-control>
                            </td>
                            <td width="67">{{'￥' + (getShowProductReq(good)).toFixed(accuracy)}}</td>
                            <td width="75" v-if="preferentialPrice[good.uid] && preferentialPrice[good.uid].childType !== 8">
                              {{'￥' + (getShowProductReq(good) + getShowPreferentialPrice(good)).toFixed(accuracy)}}
                            </td>
                            <td width="75" v-else>
                              {{'￥' + getShowProductReq(good).toFixed(accuracy)}}
                            </td>
                            <td width="82" v-if="preferentialPrice[good.uid] && preferentialPrice[good.uid].childType === 8">
                              {{'￥' + (good.totalPrice + getShowPreferentialPrice(good)).toFixed(accuracy)}}
                            </td>
                            <td width="82" v-else-if="preferentialPrice[good.uid] && preferentialPrice[good.uid].childType !== 8">
                              {{'￥' + (good.totalPrice + getShowPreferentialPrice(good) * good.num).toFixed(accuracy)}}
                            </td>
                            <td width="82" v-else>
                              {{'￥' + (good.totalPrice).toFixed(accuracy)}}
                            </td>
                            <!-- <td width="80" v-if="good.stockNum">{{good.stockNum}} {{$t('system.points')}}</td> -->
                          </group-info>
                        </template>
                        <template v-else>
                          <div>
                            <td width="160" class="text-left">
                              <div>
                                <p>{{ $i18n.locale === 'zh' ? good.name : (good.nameEn || good.name) }}</p>
                                <p class="good-requirement" v-if="good.isRequirement && good.listRequirements && good.listRequirements.length">
                                  {{
                                    good.requirements
                                      .reduce((acc, property) => [].concat(acc, property.items
                                        .filter(val => val.isSelect)
                                          .map(valMap => valMap.name)), [])
                                    .join('、')
                                  }}
                                </p>
                              </div>
                            </td>
                            <!-- <td width="10"></td> -->
                            <td width="90">
                              <cart-control
                                :food="good"
                                :index="index"
                                :site="'cart'"
                                @ADD_TO_CART="ADD_TO_CART"
                                class="item-change"></cart-control>
                            </td>
                            <td width="67">{{'￥' + (getShowProductReq(good)).toFixed(accuracy)}}</td>
                            <td width="75" v-if="preferentialPrice[good.uid] && preferentialPrice[good.uid].childType !== 8">
                              {{'￥' + (getShowProductReq(good) + getShowPreferentialPrice(good)).toFixed(accuracy)}}
                            </td>
                            <td width="75" v-else>
                              {{'￥' + getShowProductReq(good).toFixed(accuracy)}}
                            </td>
                            <td width="82" v-if="preferentialPrice[good.uid] && preferentialPrice[good.uid].childType === 8">
                              {{'￥' + ((good.totalPrice + Number(good.requirementPrice||0)) + getShowPreferentialPrice(good)).toFixed(accuracy)}}
                            </td>
                            <td width="82" v-else-if="preferentialPrice[good.uid] && preferentialPrice[good.uid].childType !== 8">
                              {{'￥' + ((good.totalPrice + Number(good.requirementPrice||0)) + getShowPreferentialPrice(good) * good.num).toFixed(accuracy)}}
                            </td>
                            <td width="82" v-else>
                              {{'￥' + ((good.totalPrice + Number(good.requirementPrice||0))).toFixed(accuracy)}}
                            </td>

                            <!-- <td width="80" v-if="good.stockNum">{{good.stockNum}} 积分</td> -->
                          </div>
                        </template>
                        <!-- <td width="100">{{'￥' + good.price}}</td> -->

                        <!-- <td class="btn-right">
                          <Button v-if="good.type===2" @click.native="$showGroup(good)">{{'套餐详情'}}</Button>
                          <Button v-if="good.isRequirement" @click.native="$showRequiremt(index)">{{'特殊要求'}}</Button>
                        </td> -->
                      </tr>
                      <!-- <tr v-if="good.isRequirement && isShowRequiremt[index]">
                        <td class="reqs__tb" colspan="4">
                          <cd-requirement :product="good" class="cd-requirement" :pIndex="index"></cd-requirement>
                        </td>
                      </tr> -->
                    </tbody>
                  </table>
                  <table v-for="(pres, index) in presProducts" :key="`presProducts${index}`" class="tb-orders-el">
                    <tbody>
                      <tr>
                        <div>
                          <td width="160" class="text-left">
                            {{ pres.productName || pres.content }}
                          </td>
                          <!-- <td width="10"></td> -->
                          <td width="90">
                            <cart-control
                              :food="pres"
                              :index="index"
                              :site="'cart'"
                              class="item-change"></cart-control>
                          </td>
                          <td width="67">{{'￥' + pres.productPrice}}</td>
                          <td width="75">{{'￥' + pres.price}}</td>
                          <td width="82">{{'￥' + pres.price}}</td>
                        </div>
                      </tr>
                    </tbody>
                  </table>
                  <table v-for="(pro, index) in couponProductList" :key="`couponProductList${index}`" class="tb-orders-el">
                    <tbody>
                      <tr>
                        <div>
                          <td width="160" class="text-left">
                            {{ pro.productName || pro.aliasName }}
                          </td>
                          <!-- <td width="10"></td> -->
                          <td width="90">
                            <cart-control
                              :food="{ ...pro, num: pro.num || 1 }"
                              :index="index"
                              :site="'cart'"
                              class="item-change">
                            </cart-control>
                          </td>
                          <td width="67">{{'￥' + pro.price}}</td>
                          <td width="75">0</td>
                          <td width="82">0</td>
                        </div>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- 优惠&优惠券列表 - start -->
                <div class="order-pres">
                  <h3>
                    <Checkbox class="iview-checkbox" v-model="isPres" @on-change="selectPreferentialGroup"/>
                    <span>
                      <!-- 可享受以下优惠: -->
                      {{$t('tip.accordingToDiscount')}}
                      <!-- 根据当前订单记录，您可享受以下优惠活动 -->
                    </span>
                    <span class="order-pres-close" @click="clearPreferentialsData(() => { isPres = false })">
                      {{$t('cart.clear')}}
                    </span>
                  </h3>
                  <Spin size="large" fix v-if="isLoadingPres"></Spin>
                  <template v-if="preferentials.length">
                    <!-- 优惠活动 - start -->
                    <div class="promotions-box" v-show="showPres">
                      <div v-for="(pre, index) in preferentials" :key="index"
                        class="promotion-item">
                        <template v-if="pre.type!==5">
                          <div class="promotion-name">
                            <span>{{`${index + 1}、${pre.title}`}}</span>
                            <!-- <a @click="selectPreferential(index)" href="javascript:;">
                              <i :class="{'actived':pre.isSelect}" class="icon-radio"></i>
                            </a> -->
                            <Checkbox class="iview-checkbox" v-if="pre.type === 3 || pre.type === 4" :value="pre.isSelect" @on-change="changePreferentialsCheckbox(index, $event)"/>
                          </div>
                          <!-- 多选一 -->
                          <div v-if="pre.items.length > 0 && pre.type < 3" class="product-info-list">
                            <div
                              :class="['product-info', { 'group-select-checked': item.isSelect }]"
                              v-for="(item, ii) in pre.items"
                              :key="ii"
                              @click="changePreferentialsItem(index, ii)"
                            >
                              <i class="select-checked" v-show="item.isSelect" />
                              <img :src="item.productLogo || require('@/assets/image/product/default.png')" alt="" />
                              <div class="product-info-name">
                                <span>{{ item.content }}</span>
                                <Tooltip
                                  v-if="$i18n.locale === 'en' ? item.descEn : item.desc"
                                  max-width="233"
                                  :offset="10"
                                  transfer
                                  :content="$i18n.locale === 'en' ? item.descEn : item.desc"
                                  placement="top-end">
                                  <Icon type="md-information-circle" />
                                </Tooltip>
                                <Icon
                                  class="product-info-icon"
                                  v-if="$i18n.locale === 'en' ? !item.descEn : !item.desc"
                                  type="md-information-circle"
                                />
                              </div>
                              <div class="product-price">
                                <div class="product-price-noreq">
                                  <span>￥{{item.price}}</span>
                                  <!-- <div class="product-price-num">
                                    <Icon
                                      type="md-remove-circle"
                                      @click="$changePreferentials(index)"
                                    />
                                    <span class="control-count">{{item.isSelect ? item.num : 0}}</span>
                                    <Icon
                                      type="md-add-circle"
                                      @click="$changePreferentials(index, ii)"
                                    />
                                  </div> -->
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- <Select
                            :value="pre.items.findIndex((val) => val.isSelect)"
                            @on-change="$changePreferentials(index, $event)"
                            class="promotion__select">
                            <Option v-for="(item, i) in pre.items" :key="i"
                              :value="i"
                              :disabled="item.isDiscontinue||item.isSoldOut||!item.isInServiceTime||item.hasInventory && item.inventoryNum < item.num"
                              >
                              <span>{{item.content + (item.isSoldOut?' - ':'')}}</span>
                              <span v-if="!item.isInServiceTime">({{'productsNotInServiceTime'}})</span>
                              <span v-else-if="item.isDiscontinue&&item.isDiscontinue===true">{{'已下架'}}</span>
                              <span v-else-if="item.isSoldOut&&item.isSoldOut===true">{{已售罄'}}</span>
                              <span v-else-if="item.hasInventory && item.num>item.inventoryNum">({{'outOfStock'}})</span>
                              <span v-if="pre.type===1">{{' x' + item.num}}</span>
                            </Option>
                          </Select> -->

                          <!-- 满送餐品全送活动 -->
                          <!-- <ul v-if="pre.isSelect && pre.items.length > 0 && pre.sendProductRelation === 1" class="promotion__selects">
                            <li v-for="(item, i) in pre.items" :key="i">
                              <span :style="(item.isSoldOut&&item.isSoldOut===true) || (item.isDiscontinue&&item.isDiscontinue===true) ? 'text-decoration:line-through;':';'">{{item.content}}</span>
                              <span v-if="!item.isInServiceTime" class="error-text">({{'productsNotInServiceTime'}})</span>
                              <span v-else-if="item.isDiscontinue&&item.isDiscontinue===true" class="error-text">({{'已下架'}})</span>
                              <span v-else-if="item.isSoldOut&&item.isSoldOut===true" class="error-text">({{已售罄'}})</span>
                              <span v-else-if="item.hasInventory && item.num>item.inventoryNum" class="error-text">({{'outOfStock'}})</span>
                              <span class="error-text">{{' X ' + item.num}}</span>
                            </li>
                          </ul> -->
                        </template>
                      </div>
                    </div>
                  </template>

                  <template v-if="productPre.length > 0 && showPres">
                    <!-- 餐品优惠 -->
                    <div v-for="(pre, index) in productPre" :key="index" class="promotions-box">
                      <div v-for="(item, itemIndex) in pre.items" :key="item.pid" class="promotion-item">
                        <div class="promotion-name">
                          <!-- <i class="icon-radio actived"></i> -->
                          <span>{{`${(itemIndex + 1) + preferentials.length }、${item.content}`}}</span>
                          <Checkbox class="iview-checkbox" :value="item.isSelect" @on-change="changeProductPreferentials($event, itemIndex, index)"/>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <!-- 优惠&优惠券列表 - end -->

                <!-- 优惠券 - start -->
                <div class="coupons-box">
                  <h3>
                    <!-- 优惠券： -->
                    <Checkbox class="iview-checkbox" v-model="isCoupons" @on-change="selectCouponsGroup"/>
                    {{$t('tip.UseCoupons')}}
                  </h3>
                  <div class="coupons-select-box">
                    <Select v-model="couponId" class="coupons__select" @on-change="selectCouponsGroup(true)">
                      <Option :value="0"><!-- 不使用优惠券 --> -- {{$t('tip.unSelectCoupons')}} -- </Option>
                      <Option v-for="(item, index) in coupons" :key="index"
                        :value="item.cid">{{item.name}}</Option>
                    </Select>
                    <!-- <div class="coupon-change">
                      <span>{{'如果您有优惠码'}}，</span>
                      <a @click.stop="$showConverCoupon" href="javascript:;">{{'点击此处'}}</a>
                      <span>{{'兑换优惠券'}}</span>
                    </div> -->
                  </div>
                </div>
                <!-- 优惠券 - end -->

                <!-- 会员折扣 -->
                <div class="coupons-box" v-if="fdUserInfo.fdGradeId > 1">
                  <h3>
                    <!-- 优惠券： -->
                    <Checkbox class="iview-checkbox" v-model="isMembers" @on-change="selectMembers"/>
                    {{ preferentialsMembersNames[fdUserInfo.fdGradeId - 1] }}
                    {{ fdUserInfo.fdGradeId > 1 ? `- ${preferentialsMembers[fdUserInfo.fdGradeId - 1] * 10}折` : '' }}
                  </h3>
                </div>

                <!-- <div v-if="extraProducts.length > 0" class="order-list">
                  <table v-for="(extra, index) in extraProducts" :key="index" class="tb-orders-el">
                    <tbody>
                      <tr>
                        <td width="120">{{extra.productName}}</td>
                        <td width="100">{{'￥' + extra.price}}</td>
                        <td width="92">{{extra.count}}</td>
                        <td width="100">{{'￥' + extra.totalPrice}}</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div> -->
              </div>
              <!-- 餐品列表 - end -->

              <!-- 相关费用 - start -->
              <div class="order-fees">
                <!-- <div>
                  <p>
                    <em>{{'餐饮费'}}</em>
                    <span>{{'￥' + Math.ceil((afterPrePrice*100).toFixed(2))/100}}</span>
                  </p>
                </div>
                <div>
                  <p>
                    <em>{{'餐盒费'}}</em>
                    <span>{{'￥' + mealFee}}</span>
                  </p>
                </div> -->
<!--                 <div>
                  <p>
                    <em>已用积分</em>
                    <span>0</span>
                  </p>
                </div>
                <div>
                  <p>
                    <em>剩余积分</em>
                    <span>{{ fdUserInfo.fdPoints }}</span>
                  </p>
                </div> -->
                <div>
                  <p class="total-price__p">
                    <!-- 总额： -->
                    <em>{{$t('orders.prices[2]')}}</em>
                    <span>
                      <strong v-if="prePrice < 0" class="off-pre-price">
                        {{`${($i18n.locale === 'zh') ? '活动已优惠￥' : ''}${Math.abs(prePrice).toFixed(accuracy)}${$i18n.locale === 'en' ? ' OFF' : ''}`}}
                      </strong>
                      {{'￥'+ (totalPrice + prePrice).toFixed(accuracy) }}
                    </span>
                  </p>
                </div>
                <div v-if="mealFee > 0">
                  <p>
                    <!-- 餐盒费 -->
                    <em>{{$t('orders.fee[0]')}}</em>
                    <span>{{'￥' + mealFee}}</span>
                  </p>
                </div>
                <div>
                  <p>
                    <!-- 外送费： -->
                    <em>{{$t('orders.fee[3]')}}</em>
                    <span v-if="sendType === 2">
                      ￥0
                    </span>
                    <span v-else>
                      <em v-if="(preDeliveryPrice || cardPreDeliveryPrice) && deliveryFee > 0" class="delete">{{'￥' + deliveryFee}}</em>
                      {{'￥' + orderDeliveryFee}}
                    </span>
                  </p>
                </div>
                <div>
                  <p class="total-price__p">
                    <!-- 总额： -->
                    <em>{{$t('orders.fee[4]')}}</em>
                    <span v-if="isMembers && memberPreferentials.length">
                      {{ '￥'+ (orderTotalPrice + memberPreferentials[0].prePrice).toFixed(accuracy) }}
                    </span>
                    <span v-else>{{'￥'+ orderTotalPrice.toFixed(accuracy) }}</span>
                  </p>
                </div>
              </div>
              <!-- 相关费用 - end -->

              <!-- 套餐详情数据 - start -->
              <!-- <div v-if="isShowGroup" class="group-detail-box">
                <h3><a @click="isShowGroup=false" class="close" href="javascript:;">&times;</a></h3>
                <div v-for="(groupSet, index) in currentProductGroupSet" :key="index" class="group-detail">
                  <h4>{{currentProduct.name}}</h4>
                  <div v-for="(item, i) in groupSet" :key="i" class="group-item clearfix">
                    <div class="item-name">
                      <span>{{item.name + (item.price>0?'￥'+item.price:'')}}</span>
                      <span v-if="item.listPropertys.length > 0">
                        <span v-for="(property, $index) in item.listPropertys" :key="$index">
                          <span v-if="$index==0">(</span>
                          <span>{{'第X份'|replaceX('X', $index+1)}}</span>
                          <span v-for="(prop, ii) in property.propertys" :key="ii">
                            <em class="normal">
                              {{prop.name + (prop.price>0?'￥'+prop.price:'') + (ii == property.propertys.length-1  ? '' : ',')}}
                            </em>
                          </span>
                          <span v-if="$index==item.listPropertys.length-1">)</span>
                          <span v-else>,</span>
                        </span>
                      </span>
                    </div>
                    <div class="item-num">{{item.num }} {{份'}}</div>
                  </div>
                </div>
              </div> -->
              <!-- 套餐详情数据 - end -->
              <div class="to-next">
                <a href="javascript:void(0);" @click.stop="backToBooking">
                  {{$t('orders.addItem')}}
                </a>
                <Button class="cd-btn" size="large" @click.stop="toOrderSubmit">
                  {{$i18n.locale === 'zh' ? $t('cart.checkout') : $t('system.nextPage')}}
                </Button>
              </div>
            </div>
            <!-- 点餐单 - end -->
          </div>
          <div class="add-product" v-show="!isSubmit">
            <h2>{{$t('text.like')}}</h2>
            <ul
              class="menu-small-product"
              v-if="temptationProducts && temptationProducts.length"
            >
              <li
                v-for="product in temptationProducts.slice(0 , 2)"
                :key="product.uid"
                :class="{ 'product-select-checked': cartUid[product.uid] }"
              >
                <img :src="product.logo || require('@/assets/image/product/default.png')" :alt="product.name">
                <div class="product-info">
                  <i class="select-checked" v-show="cartUid[product.uid]"/>
                  <p class="product-info-name">
                    <span>{{ $i18n.locale === 'zh' ? product.name : (product.nameEn || product.name) }}</span>
                    <Tooltip
                      v-if="$i18n.locale === 'en' ? product.descEn : product.desc"
                      max-width="233"
                      :offset="10"
                      transfer
                      :content="$i18n.locale === 'en' ? product.descEn : product.desc"
                      placement="top-end">
                      <Icon type="md-information-circle" class="product-info-icon"/>
                    </Tooltip>
                    <Icon
                      class="product-info-icon"
                      v-if="$i18n.locale === 'en' ? !product.descEn : !product.desc"
                      type="md-information-circle"
                    />
                  </p>
                  <div class="product-price">
                    <div class="product-price-noreq" v-if="!product.isRequirement">
                      <span v-if="product.costPrice">
                        <s>
                          ￥{{ product.costPrice }}
                        </s>
                      </span>
                      <span v-if="product.startPrice">
                        ￥{{ product.startPrice }}{{$t('system.orAbove')}}
                      </span>
                      <span v-if="!product.startPrice">￥{{product.price}}</span>
                      <!-- <span v-if="product.hasStock && product.enableRepertory" class="stock-num">
                        {{ product.stockNum}} {{$t('system.points')}}
                      </span> -->
                      <Icon
                        type="md-add-circle"
                        @click="addTemptationProductsToCart(product, 1)"
                      />
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <Button class="cd-btn" type="error" size="large" @click="changeTtemptationProducts">
              {{$t('text.more')}}
            </Button>
          </div>
        </div>
        <!-- 订单结算 板块-->
        <div class="order-supplement" :key="'supplement' + index" v-show="isSubmit">
          <h3 class="title"><!-- 订单详情 -->{{$t('text.information')}}</h3>
          <div class="user-address-info">
            <div class="address-info-item other-info-box">
              <span class="box-label">{{$t('user.name')}}</span>
              <Input class="iview-input" v-model="submit.name" :placeholder="$t('tip.input.enterFullName')"/>
            </div>
            <div class="address-info-item other-info-box">
              <!-- <span class="box-label">电话</span> -->
              <span class="box-label">{{$t('user.phone.mobile')}}</span>
              <Input class="iview-input" v-model="submit.phone"/>
            </div>
            <div class="address-info-item other-info-box">
              <span class="box-label">{{$t('tip.input.orderType')}}</span>
              <span>{{ sendType > 1 && sendType !== 4 ? $t('text.address.business[1]') : $t('text.address.business[0]')}}</span>
              <span class="info-item-change" @click="toBackAddress">[{{$t('button.modify')}}]</span>
            </div>
            <div class="address-info-item other-info-box">
              <span class="box-label" v-if="sendType === 2">{{$t('tip.outDetail')}}</span>
              <span class="box-label" v-else>{{$t('tip.detail')}}</span>
              <span>{{ submit.address }}</span>
              <span class="info-item-change" @click="toBackAddress">[{{$t('button.modify')}}]</span>
            </div>
            <div class="address-info-item other-info-box" v-if="isSubmit">
              <template v-if="sendType === 2">
                <span class="box-label">{{$t('tip.mealTime')}}</span>
                <template v-if="sendType === 2">
                  <Select :value="selfGetTime" class="select-time" @on-change="changeSelfGetTime">
                    <template v-for="(take, index) in takeSelfTime">
                      <Option
                        v-for="item in take.times"
                        :key="`${index}${item}${take.date}`"
                        :value="`${take.date} ${item}`">{{ `${take.date} ${item}` }}</Option>
                    </template>
                  </Select>
                </template>
              </template>
              <template v-else>
                <span class="box-label">{{$t('tip.deliveryTime')}}</span>
                <Select :value="selfGetTime" class="select-time" @on-change="changeSelfGetTime">
                  <Option :value="'now'" v-if="isServerTime">{{$t('tip.ImmediateDelivery')}}</Option>
                  <template v-for="appointment in appointmentTime">
                    <Option
                      v-for="(item, index) in appointment.times"
                      :key="`${item}${index}${appointment.date}`"
                      :value="`${appointment.date} ${item}`">{{ `${appointment.date} ${item.slice(0, -3)}` }}</Option>
                  </template>
                </Select>
                <span v-if="selfGetTime === 'now' && estimatedTime" class="select-time-now">预计{{ moment.Format("HH:mm", estimatedTime) }}送达</span>
              </template>
            </div>
            <div class="address-info-item other-info-box">
              <span class="box-label">{{$t('store.cutlery.text')}}</span>
              <div class="cutlery__select">
                <Select v-model="peopleNum">
                  <Option :value="0" style="display:none;"><!-- 请选择 -->{{$t('store.cutlery.tip')}}</Option>
                  <Option :value="99"><!-- 不需要餐具 -->{{$t('store.cutlery.not')}}</Option>
                  <Option v-for="(num, i) in dinnerService" :key="i" :value="num">{{`${$t(i==0?'store.cutlery.y':'store.cutlery.x', {num: num})}`}}</Option>
                  <Option :value="-10">{{$t('store.cutlery.more')}}</Option>
                </Select>
              </div>
            </div>
          </div>
          <div class="delivery-info-box">
            <div>
              <!-- <div class="address-info-wrap">
                <div v-if="sendType!=2&&(submit.longitude!=0||addresses.length > 0)" class="address-located">
                  <div class="title-box">
                    <h3 class="title-h">{{ item.fields.sendMenuInfoName.val }}</h3>
                    <span @click.stop="$editAddress('add')" class="add-address__btn" href="javascript:;">{{'+ 新增地址'}}</span>
                  </div>
                  <div class="address-info-box">
                    <div class="address-info" :class="{
                      'err-address': !isPass&&submit.longitude>0&&submit.latitude>0&&lang=='zh',
                      'err-address-hk': !isPass&&submit.longitude>0&&submit.latitude>0&&lang=='hk',
                      'err-address-en': !isPass&&submit.longitude>0&&submit.latitude>0&&lang=='en'}">
                      <span class="user-name">{{submit.name}}</span>
                      <span class="user-phone">{{submit.phone}}</span>
                      <p>{{submit.address}}</p>
                    </div>
                    <a @click.stop="$editAddress('edit')" class="edit-address__btn" href="javascript:;">
                    {{'编辑送餐地址'}}</a>
                  </div>
                </div>
                <div v-else-if="sendType!=2 && !addresses.length&&submit.longitude==0"
                  @click.stop="$editAddress('add')"
                  class="address-unlocated">
                  <a class="create__btn" href="javascript:;">{{'新增送餐地址'}}</a>
                </div>
                <p v-if="sendType==4 && selfGetTime!=''" style="color:#ff8b00;margin:15px 0px;">
                  {{'外卖预送达时间: X'|replaceX('X', selfGetTime)}}
                </p>
                <div v-if="sendType!=2" class="address-list-box">
                  <dl v-for="(address, index) in addresses" :key="index"
                    @click.stop="$selectAddress(index, address)"
                    :class="{
                      actived:index===currentAddressIndex,
                      'err-address': !address.isRange&&lang=='zh',
                      'err-address-hk': !address.isRange&&lang=='hk',
                      'err-address-en': !address.isRange&&lang=='en' }"
                    class="address-user__dl">
                    <dt class="address-name">{{address.receiverName}}</dt>
                    <dd class="address-phone">{{address.receiverPhone}}</dd>
                    <dd class="address-txt" :title=" address.receiverAddress||'' ">{{(address.receiverAddress||'') + (address.appendReceiverAddress||'')}}</dd>
                  </dl>
                </div>
                <div v-if="sendType == 2" class="take-self-box">
                  <div class="input-box">
                    <span>{{'取餐人: '}}</span>
                    <cd-input v-model="submit.name"
                      @blur.native="validName"
                      :placeholder="name.placeholder"
                      :class="{error:name.status=='error'}"
                      class="name__input"></cd-input>
                    <span>{{'电话: '}}</span>
                    <cd-input v-model="submit.phone"
                      @blur.native="validPhone"
                      :placeholder="phone.placeholder"
                      :class="{error:phone.status=='error'}"
                      class="phone__input"></cd-input>
                  </div>
                  <p class="tips">
                    <span>{{'取餐地址: '}}</span>
                    <span>{{storeAddress}}</span>
                  </p>
                  <P class="tips">
                    <span>{{'自取时间: '}}</span>
                    <span>{{selfGetTime}}</span>
                  </P>
                </div>
              </div> -->

              <div class="paytype-wrap other-info-box">
                <span class="box-label">{{$t('tip.payment')}}</span>
                <div class="paytype-select">
                  <RadioGroup :value="submit.payType" @on-change="submit.payType = $event">
                    <Radio
                      class="select-type-radio"
                      :label="pay"
                      :key="index"
                      v-for="(pay, index) in payTypes">
                      <span v-if="pay === 1">
                        {{$t('tip.paymentList.cash')}}
                      </span>
                      <span v-if="pay === 2">
                        {{$t('tip.paymentList.onlinePayment')}}
                      </span>
                    </Radio>
                  </RadioGroup>
                  <!-- <div class="pay-types__select types__selects">
                    <button v-if="payTypes.indexOf(1)"
                      @click.stop="submit.payType=1"
                      :class="{actived:submit.payType==1}"
                      class="type-select__btn">{{'餐到付款'}}</button>
                    <button v-if="payTypes.indexOf(2)"
                      @click.stop="submit.payType=2"
                      :class="{actived:submit.payType==2}"
                      class="type-select__btn">{{'线上支付'}}</button>
                  </div> -->
                  <div v-if="submit.payType==1" class="cash-coupon-box" style="display: none;">
                    <input type="checkbox" id="cash-coupon">
                    <div class="cash-coupon-container">
                      <Radio disabled>
                        <span>{{$t('tip.paymentList.payInCash')}}</span>
                      </Radio>
                    </div>
                  </div>
                </div>
              </div>

              <div class="invoice">
                <!-- 发票要求： -->
                <div v-if="invoiceType.length > 0" class="paytype-wrap other-info-box">
                  <span class="box-label"><!-- 发票要求： -->{{$t('tip.invoice')}}</span>
                  <div class="paytype-select">
                    <p v-if="isEInvoice" class="e-invoice-tips"><!-- 仅提供电子发票 -->{{$t('tip.e_receipt')}}</p>
                    <div v-else class="types__selects">
                      <RadioGroup :value="0" @on-change="submit.isInvoice = Boolean($event)">
                        <Radio class="select-type-radio" :label="1">
                          {{$t('tip.need')}}
                        </Radio>
                        <Radio class="select-type-radio" :label="0">
                          {{$t('tip.noNeed')}}
                        </Radio>
                      </RadioGroup>
                      <!-- <button @click.stop="submit.isInvoice=true"
                        :class="{actived:submit.isInvoice}"
                        class="type-select__btn">{{'需要'}}</button>
                      <button @click.stop="submit.isInvoice=false"
                        :class="{actived:!submit.isInvoice}"
                        class="type-select__btn">{{'不需要'}}</button> -->
                    </div>
                  </div>
                </div>
                <div v-if="submit.isInvoice && !isEInvoice && invoiceType.length > 0" class="paytype-wrap other-info-box">
                  <span class="box-label"><!-- 发票类型： -->{{$t('tip.invoiceType')}}</span>
                  <div class="paytype-select">
                    <RadioGroup
                      :value="submit.invoiceType"
                      @on-change="submit.invoiceType = ($event)"
                    >
                      <Radio
                        v-for="item in invoiceType" :key="item"
                        class="select-type-radio"
                        :label="item">
                        {{$t(`tip.invoiceTypeList[${item}]`)}}
                      </Radio>
                    </RadioGroup>
                  </div>
                </div>
                <div v-if="submit.isInvoice && !isEInvoice && submit.invoiceType === 2" class="paytype-wrap other-info-box">
                  <span class="box-label"><!-- 发票抬头： -->{{$t('tip.invoiceReceiver')}}</span>
                  <div class="paytype-select">
                    <Input class="invoice-input" v-model="submit.invoiceDesc" :placeholder="$t('tip.pleaseInputBill')"/>
                  </div>
                </div>
                <div v-if="submit.isInvoice && !isEInvoice && submit.invoiceType === 2" class="paytype-wrap other-info-box">
                  <span class="box-label">
                    <!-- 发票税号： -->
                    {{$t('tip.invoiceNum')}}：</span>
                  <!-- 请输入税号或社会信用代码 -->
                  <div class="invoice-select-box f-r">
                    <Input class="invoice-input" v-model="submit.taxNo" :placeholder="$t('tip.invoiceNumTips')" />
                  </div>
                </div>
              </div>
              <div class="notice-wrap other-info-box">
                <h3 class="title"><!-- 备注信息： -->{{$t('tip.usernote')}}</h3>
                <div style="margin: 5px 7px 7px;">
                  <textarea
                    v-model="submit.userNote"
                    class="user-note__textarea"
                    :placeholder="$t('tip.notSupportModify')"
                  >
                    </textarea>
                </div>
              </div>
            </div>

            <div class="submit-btn-box">
              <a href="javascript:void(0);" @click.stop="toOrderSubmit">
                {{$t('system.back')}}
              </a>
              <Button class="cd-btn" @click="submitOrder"><!-- 确认下单 -->{{$t('system.submit')}}</Button>
            </div>
          </div>
        </div>
      </template>
    </template>
    <!-- <cd-address v-if="modal.show && modal.template=='address'"
      :modalType="modal.type"
      :modalData="modal.data"
      @success="$addressSavedCb"
      @close="$close"></cd-address> -->

    <!-- <convert-coupon v-if="modal.show && modal.template=='convert-coupon'"
      :modalData="modal.data"
      :modalTitle="modal.title"
      @success="$couponConvertCb"
      @close="$close"></convert-coupon> -->
    <!-- 下单返券弹窗部分 - start -->
    <!-- <div v-if="isShowOrderCoupon" @click="handleOrder" class="order-coupon-wrap">
      <div @click.stop="()=>{}" class="order-coupon-box">
        <div class="coupon-title">{{orderCoupon.title}}</div>
        <div class="contain">
          <cd-swiper height='172px'>
            <div class="main">
              <p v-for="(item, index) in orderCoupon.coupons" :key="index">
                <a class="coupon-name">{{item.couponName}}</a>
                <a class="coupon-minMoney">
                  {{'订单满￥X元即可使用'|replaceX('X',item.minMoney)}}
                </a>
                <a class="coupon-offsetMoney">
                  {{'￥' + item.offsetMoney}}
                </a>
              </p>
            </div>
          </cd-swiper>
        </div>
        <Button @click.native.stop="handleOrder" sub>{{'btn_close'}}</Button>
      </div>
    </div> -->
    <!-- 下单返券弹窗部分 - end -->
  </div>
</template>
<script>
import {
  Select,
  Option,
  Checkbox,
  Icon,
  Tooltip,
  RadioGroup,
  Radio,
  Input,
  // CheckboxGroup,
} from 'iview';
import md5 from 'blueimp-md5';
// import * as Com from 'project/common';
// import cdAddress from 'project/components/User/Address';
// import convertCoupon from './modal-convert-coupon';
import { DEFAULT_PAGETYPES } from '@/config/project-defult';
import { BASEKEY, ACCURACY } from '@/config';
// import { getThridConfig, turnToRouterByType } from "project/util/thridPartUtil";
// import { products as PRODUCTS } from '@/service/expands';
// import Swiper from "project/components/Swiper/Swiper.vue";
// import cdRequirement from "../store/requirement";
import cartControl from '@/components/cart/cartcontrol.vue';
import groupInfo from '@/components/dialog/groupInfo.vue';
import moment from '@/utils/date';
// import { Vue } from 'vue/types/vue';
const nowDate = new Date();
// import { sourceToken } from '@/plugins/axios';
// const TODAY = `${nowDate.getFullYear()}-${nowDate.getMonth() + 1}-${nowDate.getDate()}`;

export default {
  name: 'order',
  beforeRouteEnter(to, from, next) {
    if (from.name === 'paying') {
      next('/user-center/order');
      return;
    }
    next((vm) => {
      // vm.sid = to.params.sid;
      const self = vm;
      self.storeId = to.params.storeId;
      self.$service.user.isLogin()
        .then(() => {
          self.initOrder();
        })
        .catch(() => {
          self.$router.replace('/');
        });
    });
  },
  computed: {
    otherComponents() { // by Allen
      return this.compArr.filter(
        x => x.type !== 'cd-page-header' && x.type !== 'cd-button',
      );
    },
    payType() {
      return this.submit.payType;
    },
    orderDeliveryFee() {
      const total = this.deliveryFee + this.preDeliveryPrice - this.cardPreDeliveryPrice;
      return total > 0 ? Math.floor((total * 100).toFixed(2)) / 100 : 0;
    },
    orderTotalPrice() {
      let deliveryFee = 0;
      if (this.sendType !== 2) {
        deliveryFee = this.deliveryFee + this.preDeliveryPrice - this.cardPreDeliveryPrice;
      }
      const goodsFee = this.afterPrePrice - this.cardPrePrice - this.couponPrice;
      return ((goodsFee > 0 ? goodsFee : 0) * 10 + this.mealFee * 10 + (deliveryFee > 0 ? deliveryFee : 0) * 10) / 10;
    },
    cartUid() {
      const ids = {};
      this.foods.forEach((pro) => {
        ids[pro.pid] = true;
      });
      return ids;
    },
    presProducts() {
      const pro = [];
      try {
        this.preferentials.forEach((pres) => {
          const isGiving = pres.type === 1 && (pres.childType === 1 || pres.childType === 3);
          const isAdd = (pres.type === 2 && pres.childType === 4);
          if ((isAdd || isGiving) && this.submit.pres[pres.pid]) {
            for (const submitPres in this.submit.pres[pres.pid]) {
              if (Object.prototype.hasOwnProperty.call(this.submit.pres[pres.pid], submitPres)) {
                const pre = pres.items.find(val => val.index === +submitPres);
                if (pre) {
                  pro.push(pre);
                }
              }
            }
          }
        });
      } catch (err) {
        return [];
      }
      return pro;
    },
    couponProductList() {
      if (!this.couponId) {
        return [];
      }
      const coupon = this.coupons.find(cou => cou.cid === this.couponId);
      if (!coupon) {
        return [];
      }
      if (coupon && coupon.type === 2 && coupon.products && coupon.products.length) {
        return coupon.products;
      }
      return [];
    },
    preferentialPrice() {
      console.log('属性');
      try {
        const source = [].concat(this.productPre, this.preferentials);
        if (!source.length) {
          return {};
        }
        const proInPre = source.filter(item => item.isSelect && (item.childType === 7 || item.childType === 8 || (item.type === 3 && item.pids && item.pids.length)));
        if (!proInPre.length) {
          return {};
        }
        const data = {};
        proInPre.forEach((item) => {
          item.pids.forEach((id) => {
            data[id] = {};
            data[id] = {
              type: item.type,
              childType: item.childType,
            };
            if (item.childType === 7) {
              data[id].price = item.items.filter(val => val.pid === id).reduce((sum, val) => sum + val.price, 0);
            } else {
              data[id].price = item.items.reduce((sum, val) => sum + val.price, 0);
            }
          });
        });
        return data;
      } catch (err) {
        console.log(err);
        return {};
      }
    },
  },
  watch: {
    couponId(newVal, oldVal) {
      if (newVal === 0) {
        this.couponPrice = 0;
        return false;
      }
      // const self = this;
      // const couponIndex = -1;
      // 这里无法根据eslint的规则来写，所以在这行先启用 for of
      // eslint-disable-next-line
      for (const [index, item] of this.coupons.entries()) {
        if (item.cid === newVal) {
          // if (!item.coupon.canUseWithPre) { // 优惠券与活动不兼容
          // }
          if (Object.keys(this.submit.pres).length > 0) { // 已选择优惠活动
            this.$Modal.confirm({
              content: this.$t('tip.couponRejectOffer'),
              onOk: () => { // 确认使用优惠券，重置优惠活动
                // for (const pre of this.preferentials) {
                //   if (pre.isSelect && pre.type !== 4) {
                //     pre.isSelect = !pre.isSelect;
                //   }
                // }
                // this.setPreferentials();
                // this.getPreferentials();
                this.isCoupons = true;
                if (this.isPres && Object.keys(this.submit.pres).length) {
                  this.clearPreferentialsData(() => {
                    this.isPres = false;
                    this.showPres = false;
                  });
                }
              },
              onCancel: () => {
                this.couponId = oldVal;
              },
            });
            return false;
            // if (this.preferentials.some(prefes => prefes.isSelect && prefes.type === 3)) { // 选择了满减活动
            //   this.$Modal.info({
            //     content: '当前优惠券与优惠活动不可共用',
            //     onOk() {
            //       this.couponId = oldVal;
            //     },
            //   });
            //   return false;
            // } if (this.preferentials.some(prefes => prefes.isSelect && prefes.type !== 4)) { // 选择了非折扣
            //   this.$Modal.confirm({
            //     content: '当前优惠券与优惠活动不可共用，是否只享受优惠券？',
            //     onOk: () => { // 确认使用优惠券，重置优惠活动
            //       // for (const pre of this.preferentials) {
            //       //   if (pre.isSelect && pre.type !== 4) {
            //       //     pre.isSelect = !pre.isSelect;
            //       //   }
            //       // }
            //       // this.setPreferentials();
            //       // this.getPreferentials();
            //       this.isCoupons = true;
            //       if (this.isPres && Object.keys(this.submit.pres).length) {
            //         this.clearPreferentialsData();
            //       }
            //     },
            //     onCancel: () => {
            //       this.couponId = oldVal;
            //     },
            //   });
            //   return false;
            // }
          }
          this.isCoupons = true;
          this.showPres = false;
          this.couponPrice = item.offsetMoney;
          break;
        }
      }
      return true;
    },
    // payType() {
    //   this.cardCode = '';
    //   this.cardPrePrice = 0;
    //   this.cardPreDeliveryPrice = 0;
    //   this.submit.cardCode = '';
    //   this.couponId = 0;
    //   this.isFirst = true;
    //   this.getPreferentials();
    // },
    // currentAddressIndex(val) {
    //   if (val !== -1) {
    //     this.isPass = this.addresses[val].isRange;
    //     this.submit.name = this.addresses[val].receiverName;
    //     this.submit.phone = this.addresses[val].receiverPhone;
    //     this.submit.address = this.addresses[val].receiverAddress + (this.addresses[val].appendReceiverAddress || '');
    //     this.submit.longitude = this.addresses[val].longitude;
    //     this.submit.latitude = this.addresses[val].latitude;
    //   }
    // },
  },
  components: {
    // cdAddress,
    // convertCoupon,
    // cdSwiper: Swiper,
    cartControl,
    Checkbox,
    Select,
    Option,
    Icon,
    Tooltip,
    RadioGroup,
    Radio,
    Input,
    [groupInfo.name]: groupInfo,
    // CheckboxGroup,
    // cdRequirement,
  },
  created() {
    // const self = this;
    // this.$service.get('isLogin',{}).then(
    //   result => {
    //     if (result.status !== 1) {
    //       window.location.href = window.location.origin;
    //       return false;
    //     }
    //     if (self.sendType !== 2) {
    //       this.$getAddresses();
    //     }
    //   }
    // )
    // this.$service.project.getThridConfig(BASEKEY)
    //   .then((data) => {
    //     if (data) {
    //       this.compArr = data.pages.settlement.json;
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    this.$service.user.isLogin()
      .then(() => this.$service.user.getUserInfo())
      .then(() => {
        this.fdUserInfo = this.$service.user.getUser().third;
        const user = this.$service.user.getUser();
        this.submit.name = (user.info.compellation || user.info.userName);
        this.submit.phone = (user.info.phone || '');
        return this.$service.project.getThridConfig(BASEKEY);
      })
      .catch(() => {
        this.$router.push('/');
      })
      .then((data) => {
        if (data) {
          this.compArr = data.pages.settlement.json;
        }
      })
      .catch((err) => {
        console.log(err);
      });
    // 刷新页面时保存购物车数据
    // window.onunload = function() {
    //   let self = this;
    //   if (~window.location.href.indexOf("order")) {
    //     let cartData = Com.Utils.data.L.get(`${___PROJECT}_cart_${self.storeId}`);
    //     if (cartData && cartData[TODAY] && cartData[TODAY].lang !== Com.Lang.current) {
    //       Utils.data.L.remove(`${___PROJECT}_cart_${self.storeId}`);
    //       return;
    //     }
    //   }
    // };
    // 初始化数据
  },
  data() {
    return {
      moment,
      compArr: DEFAULT_PAGETYPES.json,
      isLoading: false,
      // sid: '',
      storeId: 0,
      storeAddress: '',
      coordinate: [],
      menuId: 0,
      sendType: 0,
      selfGetTime: '',
      foods: [],
      extraProducts: [],
      extraPrice: 0,
      totalPrice: 0, // 餐品原价
      deliveryFee: 0, // 原外送费
      preDeliveryPrice: 0, // 优惠外送费额度
      mealFee: 0, // 餐盒费
      couponPrice: 0, // 优惠券减免价格
      afterPrePrice: 0, // 参加优惠活动后的总价
      prePrice: 0, // 参加优惠活动额度, 例如如满减则为负数-10, 减加为正数10
      cardCode: '',
      cardPreDeliveryPrice: 0,
      cardPrePrice: 0,
      cardTips: '',
      isLoadingPres: false,
      couponId: 0,
      coupons: [], // 可用优惠券列表
      isFirst: true,
      preferentials: [], // 可用优惠活动列表
      productPre: [],
      invoiceType: [],
      isEInvoice: false,
      payTypes: [],
      storage: {},
      name: {
        status: '',
        placeholder: 'nameHolder',
      },
      phone: {
        status: '',
        placeholder: 'phoneHolder',
      },
      submit: {
        name: '',
        phone: '',
        address: '',
        longitude: 0,
        latitude: 0,
        payType: 1, // {1: "线下支付", 2: "线上支付", 3: "支付宝", 4: "微信"}
        onlinePayType: 1, // submit.payType==2时生效
        isInvoice: false,
        invoiceType: 2, // {1: "手撕发票", 2: "机打发票", 3: "电子发票"}
        invoiceDesc: '', // 发票抬头
        taxNo: '',
        userNote: '',
        pres: {}, // 勾选的优惠
        productPre: [],
        cardCode: '', // 记录兑换成功后的优惠卡, 用于提前订单
      },
      randomCode: '',
      modal: {
        show: false,
        title: '',
        template: '',
        type: '',
        data: {},
      },
      // currentAddressIndex: -1,
      // addresses: [],
      location: {},
      isPass: false,
      isShowGroup: false,
      currentProductGroupSet: [],
      currentProduct: {},
      isShowRequiremt: {},
      isShowOrderCoupon: false,
      orderCoupon: {},
      orderId: 0,
      lang: this.$i18n.locale,
      people_num: 0,
      isPres: false, // 是否选中优惠活动单选框
      isCoupons: false, // 是否选中优惠券
      temptationProducts: [], // 猜你喜欢数据
      isSubmit: false,
      appointmentTime: [], // 预约时间
      takeSelfTime: [], // 自取预约时间
      waitTime: 0, // 门店处理等待时间间隔
      estimatedTime: '',
      fdUserInfo: {}, // 会员信息
      preferentialsMembers: [1, 0.98, 0.95, 0.9, 0.85, 0.8],
      preferentialsMembersNames: ['注册会员', '铜卡会员', '银卡会员', '金卡会员', '白金会员', '黑金会员'],
      isMembers: false,
      memberPreferentials: [],
      accuracy: ACCURACY,
      timer: null,
      businessTimes: [],
      isServerTime: true,
      showPres: true,
      goods: [],
      tablewareOptions: true, // 商家是否提供餐具, 默认提供
      peopleNum: 0,
      dinnerService: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    };
  },
  methods: {
    getShowProductReq(pro) {
      if (pro.type !== 2) {
        const reqPrice = pro.requirementPrice ? (pro.requirementPrice / pro.num) : 0;
        return pro.price + reqPrice;
      }
      return pro.totalPrice / pro.num;
    },
    getShowPreferentialPrice(pro) {
      try {
        if (!Object.keys(this.preferentialPrice).length || !this.preferentialPrice[pro.uid]) {
          return 0;
        }
        const proData = this.goods.filter(val => val.uid === pro.uid);
        // console.log(index, sum, until);
        if (!proData.length) {
          return 0;
        }
        if (this.preferentialPrice[pro.uid].childType === 8) {
          // 第二件半价
          const index = proData.findIndex(val => val.uid === pro.uid && val.identifying.join('-') === pro.identifying.join('-'));
          const until = proData.slice(0, index).reduce((sum, val) => sum + val.num, 0);
          if (((until % 2) + pro.num) >= 2) {
            const num = (until % 2) + pro.num;
            if (pro.type === 2) {
              // 如果是套餐
              // eslint-disable-next-line
              return -(((pro.totalPrice / num) / 2) * ((num / 2) >> 0));
            }
            // eslint-disable-next-line
            return -((pro.price / 2) * ((num / 2) >> 0));
          }
        }
        if (this.preferentialPrice[pro.uid].childType === 7) {
          // 餐品折扣
          const sum = proData.reduce((sums, val) => sums + val.num, 0);
          return (this.preferentialPrice[pro.uid].price / sum);
        }
      } catch (err) {
        console.log('error form getShowPreferentialPrice', err);
        return 0;
      }
      return 0;
    },
    // 选择餐品优惠
    changeProductPreferentials(is, itemIndex, index) {
      console.log(is);
      console.log(this.productPre[index], this.productPre[index].items[itemIndex]);
      this.productPre[index].items[itemIndex].isSelect = is;
      this.productPre[index].isSelect = this.productPre[index].items.filter(val => val.isSelect).length > 0;
      this.setPreferentials();
      this.getPreferentials();
      // .then(() => {
      //   this.isPres = Boolean(Object.keys(this.submit.pres).length);
      // });
    },
    computeMember() {
      const off = this.preferentialsMembers[this.fdUserInfo.fdGradeId - 1];
      return [{
        type: 6, // 手动打折
        childType: 1, // 会员折扣
        prePrice: -(parseFloat((this.orderTotalPrice - (this.orderTotalPrice * off)).toFixed(ACCURACY))), // 优惠金额
        pid: this.fdUserInfo.fdGradeId, // 用户ids
      }];
    },
    // 选择会员折扣
    selectMembers(val) {
      console.log(val);
      if (!val) {
        // 取消选择会员折扣
        this.memberPreferentials = [];
        return;
      }
      // const computeMember = () => {
      //   const off = this.preferentialsMembers[this.fdUserInfo.fdGradeId - 1];
      //   return [{
      //     type: 6, // 手动打折
      //     childType: 1, // 会员折扣
      //     prePrice: -(parseFloat((this.orderTotalPrice - (this.orderTotalPrice * off)).toFixed(ACCURACY))), // 优惠金额
      //     pid: this.fdUserInfo.fdGradeId, // 用户ids
      //   }];
      // };
      if (!Object.keys(this.submit.pres).length && !this.isPres && !this.couponId && !this.isCoupons) {
        // const off = this.preferentialsMembers[this.fdUserInfo.fdGradeId - 1];
        this.memberPreferentials = this.computeMember();
        this.showPres = false;
        return;
      }
      this.$Modal.confirm({
        content: this.$t('tip.notEnjoy[0]'),
        onOk: () => {
          console.log(this.orderTotalPrice, this.preferentialsMembers[this.fdUserInfo.fdGradeId - 1]);
          const memberPreferentials = this.computeMember();
          if (this.couponId || this.isCoupons) {
            this.couponId = 0;
            this.isCoupons = false;
            this.memberPreferentials = memberPreferentials;
          } else if (this.isPres) {
            this.isPres = false;
            this.showPres = false;
            if (Object.keys(this.submit.pres).length) {
              this.selectPreferentialGroup(false, () => {
                const off = this.preferentialsMembers[this.fdUserInfo.fdGradeId - 1];
                memberPreferentials[0].prePrice = -(this.orderTotalPrice - (this.orderTotalPrice * off)).toFixed(ACCURACY);
                this.memberPreferentials = memberPreferentials;
              });
            }
          } else {
            this.showPres = false;
            this.memberPreferentials = memberPreferentials;
          }
        },
        onCancel: () => {
          this.isMembers = false;
        },
      });
    },
    clearCaches() {
      sessionStorage.removeItem('booking_cart');
      sessionStorage.removeItem('booking_store');
      sessionStorage.removeItem('booking_storage');
      sessionStorage.removeItem('booking_storage_temptation');
      sessionStorage.removeItem('booking_address_info');
    },
    toBackAddress() {
      this.$Modal.confirm({
        content: this.$t('tip.skipToAddress'),
        onOk: () => {
          this.clearCaches();
          this.$router.push({ path: '/booking/address' });
        },
      });
    },
    changeSelfGetTime(value) {
      if (value === 'now') {
        this.estimatedTime = this.getEstimatedTime();
      }
      this.selfGetTime = value;
    },
    changeTtemptationProducts() {
      //  切换猜你喜欢分类
      this.temptationProducts.push(...this.temptationProducts.splice(0, 2));
    },
    toOrderSubmit() {
      // 进入订单结算页
      // const store = JSON.parse(sessionStorage.getItem('booking_store'));
      // if (this.isSubmit && this.selfGetTime === 'now' && this.estimatedTime) {
      //   this.selfGetTime = moment.Format('yyyy-MM-dd HH:mm:ss', this.estimatedTime);
      // }
      // if (!this.isSubmit && (this.sendType === 1 || this.sendType === 4)) {
      //   this.appointmentTime = store.appointmentTime.map(item => ({
      //     date: item.date,
      //     times: this.$service.order.changeTimes(item.times),
      //   }));
      //   if (!this.isServerTime) {
      //     // this.sendType = 4;
      //     // this.selfGetTime
      //     // [{ times: [this.selfGetTime] }] = this.appointmentTime;
      //     this.selfGetTime = `${this.appointmentTime[0].date} ${this.appointmentTime[0].times[0]}`;
      //     this.changeSelfGetTime(this.selfGetTime);
      //   } else {
      //     this.selfGetTime = 'now';
      //     this.changeSelfGetTime('now');
      //   }
      // } else if (!this.isSubmit && this.sendType === 2) {
      //   this.takeSelfTime = store.takeSelfTime.map(item => ({
      //     date: item.date,
      //     times: this.$service.order.changeTimes(item.times),
      //   }));
      //   this.selfGetTime = `${this.takeSelfTime[0].date} ${this.takeSelfTime[0].times[0]}`;
      // }
      this.showSelfGetTime();
      this.isSubmit = !this.isSubmit;
    },
    showSelfGetTime() {
      const store = JSON.parse(sessionStorage.getItem('booking_store'));
      if (!this.isSubmit && (this.sendType === 1 || this.sendType === 4)) {
        const isType4 = store.businessType.indexOf(4) > -1;
        if (isType4) {
          this.appointmentTime = store.appointmentTime.map(item => ({
            date: item.date,
            times: this.$service.order.changeTimes(item.times),
          }));
        }
        if (!this.isServerTime && isType4) {
          // this.sendType = 4;
          // this.selfGetTime
          // [{ times: [this.selfGetTime] }] = this.appointmentTime;
          this.selfGetTime = `${this.appointmentTime[0].date} ${this.appointmentTime[0].times[0]}`;
          this.changeSelfGetTime(this.selfGetTime);
        } else {
          this.selfGetTime = 'now';
          this.changeSelfGetTime('now');
        }
      } else if (!this.isSubmit && this.sendType === 2) {
        this.takeSelfTime = store.takeSelfTime.map(item => ({
          date: item.date,
          times: this.$service.order.changeTimes(item.times),
        }));
        this.selfGetTime = `${this.takeSelfTime[0].date} ${this.takeSelfTime[0].times[0]}`;
      }
    },
    // 清空优惠活动
    clearPreferentialsData(onOK = Function.prototype) {
      if (Object.keys(this.submit.pres).length) {
        this.preferentials.forEach((pre) => {
          const prefe = pre;
          prefe.isSelect = false;
        });
        this.productPre.forEach((pre) => {
          const productPre = pre;
          productPre.isSelect = false;
          productPre.items.forEach((preItem) => {
            const item = preItem;
            item.isSelect = false;
          });
        });
        this.setPreferentials();
        this.getPreferentials(onOK);
        // .then(() => {
        //   onOK();
        // });
      }
      this.isPres = false;
    },
    selectCouponsGroup(val) {
      if (!val) {
        this.couponId = 0;
        return;
      }
      // 是否选中优惠活动
      if (!Object.keys(this.submit.pres).length && !this.isPres && !this.isMembers) {
        return;
      }
      let content;
      if (this.isMembers) {
        content = this.$t('tip.notEnjoy[0]');
      } else if (this.isPres || Object.keys(this.submit.pres).length) {
        content = [this.$t('tip.cannontUseTogether'), this.$t('tip.changeClear')];
      } else {
        return;
      }
      this.$Modal.confirm({
        content,
        onOk: () => {
          if (this.isMembers) {
            this.isMembers = false;
            this.selectMembers(false);
          }
          if (this.isPres && Object.keys(this.submit.pres).length) {
            this.clearPreferentialsData(() => {
              this.isPres = false;
              this.showPres = false;
            });
          } else if (this.isPres) {
            this.isPres = false;
            this.showPres = false;
          }
          this.isCoupons = true;
        },
        onCancel: () => {
          if (this.couponId) {
            this.couponId = 0;
          }
          this.isCoupons = false;
        },
      });
    },
    checkPreferentialOther() {
      let content;
      if (this.couponId || this.isCoupons) {
        content = [this.$t('tip.cannontUseTogether'), this.$t('tip.changeClear')];
      } else if (this.isMembers) {
        content = this.$t('tip.notEnjoy[0]');
      } else {
        this.isPres = true;
        this.showPres = true;
        return false;
      }
      this.$Modal.confirm({
        content,
        onOk: () => {
          if (this.couponId) {
            this.couponId = 0;
          }
          if (this.isMembers) {
            this.isMembers = false;
            this.selectMembers(false);
          }
          this.isCoupons = false;
          this.isPres = true;
          this.showPres = true;
        },
        onCancel: () => {
          this.isPres = false;
          this.showPres = false;
        },
      });
      return content;
    },
    selectPreferentialGroup(val, onOK = Function.prototype) {
      // 是否选中优惠活动
      console.log(this.preferentials);
      if (!val) {
        // this.preferentials.forEach((pre) => {
        //   pre.isSelect = false;
        //   // pre.items.forEach((item) => {
        //   //   item.isSelect = false;
        //   // });
        // });
        // for (const pre of this.preferentials) {
        //   pre.isSelect = false;
        // }
        // this.productPre.forEach((productPre) => {
        //   productPre.isSelect = false;
        //   productPre.items.forEach((item) => {
        //     item.isSelect = false;
        //   });
        // });
        // this.setPreferentials();
        this.clearPreferentialsData(onOK);
        this.showPres = false;
        // this.getPreferentials().then(() => { onOK(); });
        return;
      }
      this.checkPreferentialOther();
    },
    addTemptationProductsToCart(product, num) {
      // 添加猜你喜欢餐品进购物车
      const { foods: cartData } = JSON.parse(sessionStorage.getItem('booking_storage'));
      const fIndex = cartData.findIndex(val => val.pid === product.uid);
      // 是否存在购物车里
      if (fIndex > -1) {
        const cartFood = cartData[fIndex];
        cartFood.num += Number(num);
        cartFood.totalPrice = parseFloat((cartFood.price * cartFood.num).toFixed(ACCURACY));
        this.ADD_TO_CART(cartFood, fIndex);
        return;
      }
      const food = product;
      food.identifying = [food.uid];
      food.num += Number(num);
      food.totalPrice = parseFloat((food.price * food.num).toFixed(ACCURACY));
      console.log(food);
      const obj = {
        ...food,
        pid: food.uid,
        typeId: food.typeId,
        num: food.num,
        name: food.name,
        price: food.price,
        mealFee: food.mealFee,
        totalPrice: food.totalPrice,
        type: food.type,
        isRequirement: food.isRequirement,
      };
      this.ADD_TO_CART(obj, cartData.length);
    },
    ADD_TO_CART(productItem) {
      const product = productItem;
      const storage = JSON.parse(sessionStorage.getItem('booking_storage'));
      const cartData = JSON.parse(sessionStorage.getItem('booking_cart'));
      // 套餐
      if (product.type === 2) {
        product.num = product.groups.reduce((accu, curr) => accu + curr.num, 0);
        product.totalPrice = product.groups.reduce((accu, curr) => accu + curr.totalPrice, 0);
      }
      // console.log(product);
      const fIndex = cartData.goods.findIndex(val => val.uid === product.uid && (val.identifying.join('-') === product.identifying.join('-')));
      // const fIndex = cartData.goods.findIndex(val => val.pid === product.pid);
      // 已存在购物车
      if (product.num === 0) {
        if (product.isRequirement) {
          product.isShowReq = false;
        }
        cartData.goods.splice(fIndex, 1);
      } else if (fIndex > -1) {
        cartData.goods.splice(fIndex, 1, product);
      } else {
        cartData.goods.push(product);
      }

      const foods = [];
      cartData.goods.forEach((food) => {
        const obj = {
          // ...food,
          pid: food.uid,
          typeId: food.typeId,
          num: food.num,
          name: food.name,
          price: food.price,
          mealFee: food.mealFee,
          totalPrice: food.totalPrice,
          type: food.type,
          isRequirement: food.isRequirement,
          pKey: food.pKey,
          uid: food.uid,
          bigTypeId: food.bigTypeId,
        };
        if (food.isRequirement) {
          Object.assign(obj, {
            listRequirements: (food.listRequirements),
            rIndex: food.listRequirements.length - 1,
            // listRequirements: Com.filterRequirement(food.listRequirements),
            requirementPrice: food.requirementPrice,
            requirements: food.requirements,
          });
        } else if (food.type === 2) {
          const groups = this.$service.menu.filterGroup(food.groups);
          Object.assign(obj, {
            groups,
            storeId: food.storeId,
            menuId: food.menuId,
            uid: food.uid,
          });
        }
        foods.push(obj);
      });
      // 存进购物车
      if (foods.length > 0) {
        sessionStorage.setItem('booking_cart', JSON.stringify({
          updateTime: `${nowDate.getFullYear()}-${nowDate.getMonth() + 1}-${nowDate.getDate()}`,
          lang: this.$i18n.locale,
          sendType: this.sendType,
          appointTime: this.selfGetTime,
          goods: [...cartData.goods],
          storeId: this.storeId,
        }));
      } else {
        sessionStorage.removeItem('booking_cart');
      }

      // 餐品总额
      const totalPrice = foods.reduce((accumulator, current) => accumulator + current.totalPrice + Number(current.requirementPrice || 0), 0);
      // 餐品份数
      const count = foods.reduce((accumulator, current) => accumulator + current.num, 0);
      // 餐盒费
      const mealFee = foods.reduce((accumulator, current) => accumulator + (current.mealFee * current.num), 0);
      storage.totalPrice = Math.ceil((totalPrice * 100).toFixed(2)) / 100;
      storage.count = count;
      storage.mealFee = Math.ceil(mealFee * 100) / 100;
      storage.foods = foods;

      sessionStorage.setItem('booking_storage', JSON.stringify(storage));

      // 判断起送条件
      if (!foods.length) {
        this.$Modal.info({ content: this.$t('tip.product.didntChoose') });
        this.backToBooking();
        return false;
      }
      if (storage.sendType !== 2) {
        if (storage.deliveryType === 1) {
          // 份数起送
          if (storage.count < storage.reachPart) {
            this.$Modal.info({ content: this.$t('tip.delivery.not') });
            this.backToBooking();
            return false;
          }
        } else if (storage.deliveryType === 2) {
          // 金额起送
          if (storage.totalPrice < storage.reachFee) {
            this.$Modal.info({ content: this.$t('tip.delivery.not') });
            this.backToBooking();
            return false;
          }
        }
      }
      this.initOrder();
      return true;
    },
    validName() {
      if (this.submit.name === '') {
        this.name.status = 'error';
        return false;
      }
      this.name.status = '';
      return true;
    },
    validPhone() {
      if (this.submit.phone === '') {
        this.phone.status = 'error';
        return false;
      }
      this.phone.status = '';
      return true;
    },
    validInvoiceDesc() {
      if (this.submit.invoiceType === 2 && (!this.submit.invoiceDesc || this.submit.invoiceDesc === '')) {
        this.$Modal.info({
          content: this.$t('tip.pleaseInputBill'),
        });
        return false;
      }
      return true;
    },
    validInvoiceType() {
      if (!this.submit.invoiceType || (this.submit.invoiceType === 2 && this.submit.invoiceDesc === '')) {
        this.$Modal.info({
          content: `${this.$t('text.select')} ${this.$t('tip.invoiceType')}`,
        });
        return false;
      }
      return true;
    },
    validTaxNo() {
      if (this.submit.invoiceType === 2 && (!this.submit.taxNo || this.submit.taxNo === '')) {
        this.$Modal.info({
          content: this.$t('tip.pleaseInputInvoice'),
        });
        return false;
      }
      return true;
    },
    // set优惠活动提交数据
    setPreferentials() { // 选择优惠活动后按照相应结构处理相应数据, 并赋值到this.submit.pres
      const pres = {};
      for (const pre of this.preferentials) {
        const { pid } = pre;
        if (pre.isSelect) {
          let index = -1; let
            num = 0;
          for (const item of pre.items) {
            if (item.isSelect) {
              // index = item.index;
              ({ num, index } = item);
              if (Object.prototype.hasOwnProperty.call(pres, pid)) {
                Object.assign(pres[pid], {
                  [index]: num,
                });
              } else {
                Object.assign(pres, {
                  [pid]: {
                    [index]: num,
                  },
                });
              }
            }
          }
          // if (index > -1) {
          //   Object.assign(pres, {
          //     [pid]: {
          //       [index]: num
          //     }
          //   })
          // }
        }
      }
      this.productPre.forEach((pre) => {
        const { pid } = pre;
        pre.items.forEach((item) => {
          console.log(item.isSelect);
          if (item.isSelect) {
            if (Object.prototype.hasOwnProperty.call(pres, pid)) {
              Object.assign(pres[pid], {
                [item.index]: item.num,
              });
            } else {
              Object.assign(pres, {
                [pid]: {
                  [item.index]: item.num,
                },
              });
            }
          }
        });
      });
      // for (const pre of this.productPre) {
      //   const { pid } = pre;
      //   for (const item of pre.items) {
      //     if (item.isSelect) {
      //       if (Object.prototype.hasOwnProperty.call(pres, pid)) {
      //         Object.assign(pres[pid], {
      //           [item.index]: item.num,
      //         });
      //       } else {
      //         Object.assign(pres, {
      //           [pid]: {
      //             [item.index]: item.num,
      //           },
      //         });
      //       }
      //     }
      //   }
      // }
      this.submit.pres = { ...pres };
    },
    // 切换选择优惠活动
    selectPreferential(index, childIndex) {
      const child = childIndex;
      if (this.preferentials[index].type === 3 || this.preferentials[index].type === 4) {
        if (this.preferentials[index].isSelect) {
          return false;
        }
      }

      if (!this.preferentials[index].isSelect) {
        const selectedArr = []; // 选中&&不兼容的活动
        const unCompatibleArr = [];
        // let unCompatibleIndex = -1;

        this.preferentials.forEach((pre, i) => {
          if (!pre.isCompatible) {
            unCompatibleArr.push(i);
            // if (pre.isSelect) {
            //   unCompatibleIndex = i;
            // }
          }
          if (pre.isSelect) {
            selectedArr.push(i);
          }
        });

        // 不存在互斥活动满减、折扣不可不选
        // if ((!unCompatibleArr.length || this.preferentials.length === 1)) {
        //   return false;
        // }

        // 判断活动兼容性
        if (!this.preferentials[index].isCompatible && selectedArr.length) {
          // 选择不兼容优惠活动
          // 活动没选中的情况
          this.$Modal.confirm({
            content: this.$t('tip.notEnjoy[1]'),
            onOk: () => {
              selectedArr.forEach((i) => {
                this.preferentials[i].isSelect = false;
              });
              this.preferentials[index].isSelect = !this.preferentials[index].isSelect;

              if (this.preferentials[index].isSelect && this.preferentials[index].type === 1 && (this.preferentials[index].childType === 1 || this.preferentials[index].childType === 3)) {
                this.selectPreferentialsType1AndChildType1(index, child);
              } else if (this.preferentials[index].isSelect && (child === 0 || child)) {
                if (!this.preferentials[index].items[child].isForceChoice) {
                  this.preferentials[index].items[child].isSelect = !this.preferentials[index].items[child].isSelect;
                } else {
                  this.preferentials[index].items[child].isSelect = true;
                }
              }

              // if (this.preferentials[index].isSelect) {
              //   if (this.preferentials[index].type === 1 && this.preferentials[index].sendProductRelation === 1) {
              //     for (const item of this.preferentials[index].items) {
              //       if (!item.isSoldOut && item.isInServiceTime) {
              //         item.isSelect = true;
              //       }
              //     }
              //   } else if ((this.preferentials[index].type === 1 && this.preferentials[index].sendProductRelation !== 1) || this.preferentials[index].type === 2) {
              //     for (const [ii, item] of this.preferentials[index].items.entries()) {
              //       if (!item.isSoldOut && item.isInServiceTime) {
              //         child = ii;
              //         break;
              //       } else {
              //         child = 0;
              //       }
              //     }
              //   } else {
              //     child = 0;
              //   }
              // }

              // if (child === 0 || child) {
              //   if (!this.preferentials[index].items[child].isForceChoice) {
              //     this.preferentials[index].items[child].isSelect = !this.preferentials[index].items[child].isSelect;
              //   } else {
              //     this.preferentials[index].items[child].isSelect = true;
              //   }
              // }

              this.setPreferentials();
              // this.getPreferentials(this.preferentials[index].pid, this.preferentials[index].isSelect, child);
              this.getPreferentials();
            },
            // onCancel() {
            //   return false;
            // },
          });
          return false;
        }
        if (this.preferentials[index].isCompatible) { // 选择兼容优惠活动
          let isCompatible = true;
          let sIndex = -1;
          // let preferentials = [...this.preferentials, ...this.productPre];
          for (const [i, pre] of this.preferentials.entries()) {
            if (!pre.isCompatible && pre.isSelect) {
              isCompatible = false;
              sIndex = i;
              break;
            }
          }

          if (!isCompatible) {
            this.$Modal.confirm({
              content: this.$t('tip.notEnjoy[1]'),
              onOk: () => {
                this.preferentials[sIndex].isSelect = false; // 已选择的活动取消选择

                // this.couponId = 0;
                this.preferentials[index].isSelect = !this.preferentials[index].isSelect;

                if (this.preferentials[index].isSelect && this.preferentials[index].type === 1 && (this.preferentials[index].childType === 1 || this.preferentials[index].childType === 3)) {
                  this.selectPreferentialsType1AndChildType1(index, child);
                } else if (this.preferentials[index].isSelect && (child === 0 || child)) {
                  if (!this.preferentials[index].items[child].isForceChoice) {
                    this.preferentials[index].items[child].isSelect = !this.preferentials[index].items[child].isSelect;
                  } else {
                    this.preferentials[index].items[child].isSelect = true;
                  }
                }

                // if (this.preferentials[index].isSelect) {
                //   if (this.preferentials[index].type === 1 && this.preferentials[index].sendProductRelation === 1) {
                //     for (const item of this.preferentials[index].items) {
                //       if (!item.isSoldOut && item.isInServiceTime) {
                //         item.isSelect = true;
                //       }
                //     }
                //   } else if ((this.preferentials[index].type === 1 && this.preferentials[index].sendProductRelation !== 1) || this.preferentials[index].type === 2) {
                //     for (const [ii, item] of this.preferentials[index].items.entries()) {
                //       if (!item.isSoldOut && item.isInServiceTime) {
                //         child = ii;
                //         break;
                //       } else {
                //         child = 0;
                //       }
                //     }
                //   } else {
                //     child = 0;
                //   }
                // }

                // if (child === 0 || child) {
                //   if (!this.preferentials[index].items[child].isForceChoice) {
                //     this.preferentials[index].items[child].isSelect = !this.preferentials[index].items[child].isSelect;
                //   }
                // }
                this.setPreferentials();
                // this.getPreferentials(this.preferentials[index].pid, this.preferentials[index].isSelect, child);
                this.getPreferentials();
              },
              onCancel() {
                return false;
              },
            });
            return false;
          }
        }

        // 判断与优惠券兼容性
        if (!this.preferentials[index].isSelect && this.preferentials[index].type !== 4) {
          if (this.couponId > 0) {
            // const arr = this.coupons.filter(item => item.couponId === this.couponId);
            // const bar = arr.some(item => !item.coupon.canUseWithPre);
            const reject = this.coupons.filter(item => item.cid === this.cid).some(item => !item.coupon.canUseWithPre);

            if (reject) {
              this.$Modal.confirm({
                content: this.$t('tip.notEnjoy[2]'),
                onOk() {
                  this.couponId = 0;
                  this.preferentials[index].isSelect = !this.preferentials[index].isSelect;

                  if (this.preferentials[index].isSelect && this.preferentials[index].type === 1 && (this.preferentials[index].childType === 1 || this.preferentials[index].childType === 3)) {
                    this.selectPreferentialsType1AndChildType1(index, child);
                  } else if (this.preferentials[index].isSelect && (child === 0 || child)) {
                    if (!this.preferentials[index].items[child].isForceChoice) {
                      this.preferentials[index].items[child].isSelect = !this.preferentials[index].items[child].isSelect;
                    } else {
                      this.preferentials[index].items[child].isSelect = true;
                    }
                  }

                  // if (this.preferentials[index].isSelect) {
                  //   if (this.preferentials[index].type === 1 || this.preferentials[index].type === 2) {
                  //     for (const [ii, item] of this.preferentials[index].items.entries()) {
                  //       if (!item.isSoldOut && item.isInServiceTime) {
                  //         child = ii;
                  //         break;
                  //       } else {
                  //         child = 0;
                  //       }
                  //     }
                  //   } else {
                  //     child = 0;
                  //   }
                  // }

                  // if (child === 0 || child) {
                  //   if (!this.preferentials[index].items[child].isForceChoice) {
                  //     this.preferentials[index].items[child].isSelect = !this.preferentials[index].items[child].isSelect;
                  //   }
                  // }
                  this.setPreferentials();
                  // this.getPreferentials(this.preferentials[index].pid, this.preferentials[index].isSelect, child);
                  this.getPreferentials();
                },
                onCancel() {
                  return false;
                },
              });
              return false;
            }
          }
        }

        this.preferentials[index].isSelect = !this.preferentials[index].isSelect;
        // if (this.preferentials[index].isSelect) {
        //   if (this.preferentials[index].type === 1 && this.preferentials[index].sendProductRelation === 1) {
        //     for (const item of this.preferentials[index].items) {
        //       if (!item.isSoldOut && item.isInServiceTime) {
        //         item.isSelect = true;
        //       }
        //     }
        //   } else if ((this.preferentials[index].type === 1 && this.preferentials[index].sendProductRelation !== 1) || this.preferentials[index].type === 2) {
        //     for (const [ii, item] of this.preferentials[index].items.entries()) {
        //       if (!item.isSoldOut && item.isInServiceTime) {
        //         child = ii;
        //         break;
        //       } else {
        //         child = 0;
        //       }
        //     }
        //   } else {
        //     child = 0;
        //   }
        // }
      }
      if (child === 0 || child) {
        if (this.preferentials[index].type === 1 && (this.preferentials[index].childType === 1 || this.preferentials[index].childType === 3)) {
          this.selectPreferentialsType1AndChildType1(index, child);
        } else if (this.preferentials[index].items.length > 0 && !this.preferentials[index].items[child].isForceChoice) {
          this.preferentials[index].items[child].isSelect = !this.preferentials[index].items[child].isSelect;
        }
      }
      this.setPreferentials();

      // this.getPreferentials(this.preferentials[index].pid, this.preferentials[index].isSelect, child);
      this.getPreferentials();
      return true;
    },
    selectPreferentialsType1AndChildType1(index, child) {
      // 满送餐品 多送一 or 多送多 选择逻辑处理
      if (this.preferentials[index].sendProductRelation !== 1) {
        // 满送餐品 多送一的
        this.preferentials[index].items.forEach((item, itemIndex) => {
          const pre = item;
          if (pre.isSelect && itemIndex !== child && !pre.isSoldOut && pre.isInServiceTime) {
            pre.isSelect = false;
          }
        });
        this.preferentials[index].items[child].isSelect = !this.preferentials[index].items[child].isSelect;
      } else {
        // 多送多的
        const setVal = !this.preferentials[index].items[child].isSelect;
        this.preferentials[index].items.forEach((item) => {
          const pre = item;
          if (!pre.isSoldOut && pre.isInServiceTime) {
            pre.isSelect = setVal;
          }
        });
      }
    },
    // 选择优惠活动，多选
    changePreferentialsItem(index, child) {
      console.log(this.preferentials[index].items[child].isSelect);
      // if (!this.preferentials[index].isSelect) {
      //   this.selectPreferential(index);
      //   return;
      // }
      // if (this.preferentials[index].items[child].isSelect) {
      //   // 已选择
      //   // this.preferentials[index].items[child].isSelect = false;
      //   // this.preferentials[index].isSelect = this.preferentials[index].items.filter(val => val.isSelect).length > 0;
      //   // this.setPreferentials();
      //   // this.getPreferentials(this.preferentials[index].pid, this.preferentials[index].isSelect, child);
      //   this.selectPreferential(index, child);
      // } else {
      //   // 未选择
      //   // if (!this.preferentials[index].isSelect) {
      //   //   this.preferentials[index].isSelect = true;
      //   // }
      //   this.selectPreferential(index, child);
      // }
      if (
        (this.preferentials[index].type === 1 || this.preferentials[index].type === 2)
        && (this.preferentials[index].items[child].isSoldOut
        || !this.preferentials[index].items[child].isInServiceTime)
      ) {
        // 满加、满送活动餐品是否售罄
        // 作出相应提示
        this.$Modal.info({ content: this.$t('tip.inStock') });
        return;
      }
      this.selectPreferential(index, child);
    },
    // 选择优惠活动，单选
    changePreferentialsCheckbox(index, val) {
      console.log(val);
      if (!val) {
        this.preferentials[index].isSelect = false;
        this.setPreferentials();
        // this.getPreferentials(this.preferentials[index].pid, this.preferentials[index].isSelect);
        this.getPreferentials();
      } else {
        // this.preferentials[index].isSelect = ;
        this.isPres = this.selectPreferential(index, 0);
      }
    },
    cancelExistingPre() {
      this.preferentials.filter(val => val.isSelect)
        .forEach((val, index) => {
          this.preferentials[index].isSelect = false;
        });
      this.setPreferentials();
      this.getPreferentials();
    },
    // 切换优惠活动item
    // $changePreferentials(pIndex, value) {
    //   if (value === undefined) {
    //     this.selectPreferential(pIndex);
    //     return;
    //   }
    //   // 取消之前option的isSelect状态
    //   this.preferentials[pIndex].items.forEach((pitem) => {
    //     const item = pitem;
    //     item.isSelect = false;
    //   });
    //   // for (const item of this.preferentials[pIndex].items) {

    //   // }
    //   const target = value;
    //   this.selectPreferential(pIndex, Number(target));
    // },
    getPreferentials(onOK = Function.prototype) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => { this.getCanPreferentials().then(() => { onOK(); }); }, 300);
    },
    // 获取可用优惠列表
    // getPreferentials(pid, selected, selectIndex) {
    getCanPreferentials() {
      if (!this.isLoadingPres) {
        this.isLoadingPres = true;
        const postData = {
          storeId: this.storeId,
          menuId: this.menuId,
          price: Math.ceil(((this.totalPrice + this.extraPrice) * 100).toFixed(2)) / 100, //  餐品价格，不包含配送费
          // payType: this.submit.payType,
          orderType: this.sendType,
          selfGetTime: this.selfGetTime,
          isFirst: this.isFirst,
          pres: { ...this.submit.pres },
          products: [...this.$service.menu.filterProducts(this.foods)],
        };
        if (postData.selfGetTime === 'now') {
          postData.selfGetTime = moment.Format('yyyy-MM-dd HH:mm:ss', this.getEstimatedTime());
        }
        return this.$service.preferential.product.pre({ content: postData })
          .then((result) => {
            this.isFirst = false;
            // 产品为0的时候，取消DC的弹窗英文提示
            // if(!postData.products.length|| !result.$.checkResult(result,true)){return false;}

            this.afterPrePrice = result.data.aftPrePrice;
            this.preDeliveryPrice = result.data.preDeliveryPrice;
            this.prePrice = result.data.prePrice;

            // for (const pre of result.data.pres) {
            //   if (pre.selectType === 0) {
            //     for (const item of pre.items) {
            //       if (item.isSelect) {
            //         pre.isSelect = true;
            //         break;
            //       }
            //       pre.isSelect = false;
            //     }
            //     if (!pre.isSelect) {
            //       pre.isSelect = false;
            //     }
            //   }
            // }

            // 非第一次请求
            // if (!this.isFirst && pid) {
            //   for (const pre of result.data.pres) {
            //     if (pre.pid === pid) {
            //       if (selected) { // 从不选中切换到选中
            //         pre.isSelect = true;
            //         if (selectIndex) {
            //           pre.items[selectIndex].isSelect = selected;
            //         } else if (pre.type === 1 && pre.sendProductRelation === 1) {
            //           for (const item of pre.items) {
            //             if (!item.isSoldOut && item.isInServiceTime) {
            //               // item.isSelect = true;
            //             }
            //           }
            //         } else if ((pre.type === 1 && pre.sendProductRelation !== 1) || pre.type === 2) {
            //           if (pre.items.every(item => item.isSoldOut === true || item.isInServiceTime === false)) {
            //             pre.items[0].isSelect = selected;
            //           } else {
            //             for (const item of pre.items) {
            //               item.isSelect = false;
            //             }
            //             for (const item of pre.items) {
            //               if (!item.isSoldOut && item.isInServiceTime) {
            //                 item.isSelect = true;
            //                 break;
            //               }
            //             }
            //           }
            //         } else if (pre.items.length > 0) {
            //           pre.items[0].isSelect = selected;
            //         }
            //       } else { // 从选中切换到不选中
            //         pre.isSelect = false;
            //       }
            //     }
            //   }
            // }
            this.preferentials = result.data.pres.filter(item => item.childType !== 7 && item.type !== 3);
            const productPres = result.data.pres.filter(item => item.childType === 7 || item.type === 3);
            if (this.productPre.length) {
              // 由于dc无论如何都会计算餐品折扣金额，所以用户取消餐品折扣金额时，手动加回餐品折扣的金额
              let cumulative = 0;
              this.productPre = productPres.map((presItem) => {
                const productPresItem = presItem;
                const oldProductPres = this.productPre.find(oldVal => productPresItem.pid === oldVal.pid);
                if (oldProductPres) {
                  oldProductPres.items.forEach((item, index) => {
                    console.log(productPresItem.items[index], item, 'isSome');
                    if (!item.isSelect) {
                      productPresItem.items[index].isSelect = item.isSelect;
                      cumulative += (-productPresItem.items[index].price);
                    }
                  });
                }
                productPresItem.isSelect = productPresItem.items.every(val => val.isSelect);
                return productPresItem;
              });
              if (cumulative > 0) {
                this.prePrice += cumulative;
                this.afterPrePrice += cumulative;
              }
              console.log(cumulative);
              // this.prePrice += this.productPre.filter(val => val.isSelect)
              //   .map(mapVal =>
              //     [
              //       ...mapVal.items
              //         .filter(itemVal => itemVal.isSelect)
              //           .map(filterItemVal => -(filterItemVal.price))
              //     ])
              //   .reduce((accumulator, currentValue) => accumulator + currentValue, 0);
              // const some = this.productPre.findIndex((val) => productPres.findIndex((oldVal) => val.pid === oldVal.pid) > -1);
              // some
            } else {
              this.productPre = [...productPres];
            }
            // this.isPres = this.preferentials.length > 0 || this.productPre > 0;
            // this.isCoupons = !this.isPres;
            // let items = [];
            // for (const pre of productPres) {
            //   for (const item of pre.items) {
            //     items.push(item);
            //   }
            // }
            // this.productPre = [...items];

            this.setPreferentials();
            this.getCoupons();
          })
          .then(() => {
            if (this.isMembers && !Object.keys(this.submit.pres).length && !this.isPres && !this.couponId && !this.isCoupons) {
              // const off = this.preferentialsMembers[this.fdUserInfo.fdGradeId - 1];
              this.memberPreferentials = this.computeMember();
            }
          })
          .catch((err) => {
            if (this.$service.isCancel(err)) {
              console.log('err');
            }
          })
          .finally(() => {
            this.isLoadingPres = false;
          });
      }
      return Promise.resolve(true);
    },
    // 获取可用优惠券列表
    getCoupons() {
      // 处理餐品数据
      const products = [];
      for (const food of this.foods) {
        const product = {
          pid: food.pid,
          typeId: food.typeId,
          num: food.num,
        };
        if (food.isRequirement) {
          Object.assign(product, { listRequirements: food.listRequirements });
        }
        if (food.type === 2) {
          Object.assign(product, { groups: food.groups });
        }
        products.push(product);
      }
      const postData = {
        storeId: this.storeId,
        amount: this.afterPrePrice, // 消费金额
        price: this.totalPrice, // 餐品原价
        menuId: this.menuId,
        selfGetTime: this.selfGetTime,
        orderType: this.sendType,
        payType: this.submit.type,
        products,
        pres: { ...this.submit.pres },
      };
      this.couponPrice = 0;
      // Promise.all([
      //   this.$service.preferential.coupon.userCoupon({ content: postData }),
      //   this.$service.preferential.third.list({ content: { pageNow: 1, pageSize: 999 } }),
      // ])
      if (postData.selfGetTime === 'now') {
        postData.selfGetTime = moment.Format('yyyy-MM-dd HH:mm:ss', this.getEstimatedTime());
      }
      return this.$service.preferential.third.list({ content: { pageNow: 1, pageSize: 999 } })
        .then((thirdCouponList) => {
          // const preCouponList = couponList.data.filter(item => !item.coupon.isProductSoldout && item.coupon.isProductInServiceTime);
          const preThirdCouponListMap = new Map();
          const thirdCouponListData = thirdCouponList.data;
          for (let i = 0; i < thirdCouponListData.length; i += 1) {
            if (!thirdCouponListData[i].isProductSoldout
              && thirdCouponListData[i].isProductInServiceTime
              && !preThirdCouponListMap.has(thirdCouponListData[i].cid)) {
              preThirdCouponListMap.set(thirdCouponListData[i].cid, thirdCouponListData[i]);
            }
          }
          const preThirdCouponList = [...preThirdCouponListMap.values()];
          // const preThirdCouponList = thirdCouponList.data.filter((item, index, array) => !item.isProductSoldout
          //   && item.isProductInServiceTime
          //   && (!index || item.cid !== array[index - 1].cid)); // 去重
          return preThirdCouponList;
          // return this.$service.preferential.coupon.conversion({ content: { extIds: preThirdCouponList.map((val) => val.fdCouponId.toString()) } })
          //   .then((extIdsConversionListRes) => {
          //     const extIdsConversionList = extIdsConversionListRes.data;
          //     console.log(preCouponList, preThirdCouponList, extIdsConversionList);
          //     return [[], [], []];
          //   })
          //   .catch((err) => {
          //     return [[], [], []];
          //   })
        })
        .then(thirdCouponList => this.$service.preferential.coupon
          .conversion({ content: Object.assign({}, postData, { extIds: thirdCouponList.map(val => val.fdCouponId.toString()) }) })
          .then(couponList => (couponList.data ? couponList.data.map((coupon) => {
            const thirdItem = thirdCouponList.find(thirdCoupon => coupon.cid === thirdCoupon.cid && !coupon.isProductSoldout && coupon.isProductInServiceTime);
            if (thirdItem) {
              thirdItem.products = coupon.products;
            }
            return thirdItem;
          }).filter(val => val)
            : [])))
        .then((couponList) => {
          // console.log(couponList, thirdCouponList);
          const result = couponList;
          const coupons = result.sort((a, b) => b.offsetMoney - a.offsetMoney);

          if (coupons.length > 0) {
            let couponIndex = 0;
            let couponId = 0;
            let couponPrice = 0;
            if (this.couponId > 0) {
              for (const [index, item] of coupons.entries()) {
                if (item.cid === this.couponId) {
                  couponIndex = index;
                  ({ cid: couponId } = item);
                  couponPrice = item.offsetMoney;
                  break;
                }
              }
            } else {
              [{ cid: couponId }] = coupons;
              couponPrice = coupons[0].offsetMoney;
              if (Object.keys(this.submit.pres).length > 0) {
                for (const [index, item] of coupons.entries()) {
                  if (item.canUseWithPre === true) {
                    couponIndex = index;
                    ({ cid: couponId } = item);
                    couponPrice = item.offsetMoney;
                    break;
                  }
                }
              }
            }

            if (!coupons[couponIndex].canUseWithPre) {
              for (const pre of this.preferentials) {
                if (pre.isSelect && pre.type !== 4) {
                  couponId = 0;
                  couponPrice = 0;
                }
              }
            }
            if (!this.isPres && !this.isMembers && !this.showPres) {
              this.isCoupons = true;
              this.couponId = couponId;
              this.couponPrice = couponPrice;
            }
            this.coupons = [...coupons];
          } else {
            this.couponId = 0;
          }
        });
      // this.$service.preferential.coupon.userCoupon({ content: postData })
      //   .then(res => this.$service.preferential.third.list({ content: { pageNow: 1, pageSize: 999 } })
      //     .then((result) => {
      //       // return result.data;
      //       if (!res.data.length) {
      //         return [];
      //       }
      //       const preCon = res.data.filter(item => !item.coupon.isProductSoldout && item.coupon.isProductInServiceTime);
      //       return result.data.filter((item, index, array) => !item.isProductSoldout
      //         && item.isProductInServiceTime
      //         && (!index || item.cid !== array[index - 1].cid)
      //         && (preCon.findIndex(val => val.couponId === item.cid) > -1));
      //     }))
      //   .then((result) => {
      //     const coupons = result.sort((a, b) => b.offsetMoney - a.offsetMoney);

      //     if (coupons.length > 0) {
      //       let couponIndex = 0;
      //       let couponId = 0;
      //       let couponPrice = 0;
      //       if (this.couponId > 0) {
      //         for (const [index, item] of coupons.entries()) {
      //           if (item.cid === this.couponId) {
      //             couponIndex = index;
      //             ({ cid: couponId } = item);
      //             couponPrice = item.offsetMoney;
      //             break;
      //           }
      //         }
      //       } else {
      //         [{ cid: couponId }] = coupons;
      //         couponPrice = coupons[0].offsetMoney;
      //         if (Object.keys(this.submit.pres).length > 0) {
      //           for (const [index, item] of coupons.entries()) {
      //             if (item.canUseWithPre === true) {
      //               couponIndex = index;
      //               ({ cid: couponId } = item);
      //               couponPrice = item.offsetMoney;
      //               break;
      //             }
      //           }
      //         }
      //       }

      //       if (!coupons[couponIndex].canUseWithPre) {
      //         for (const pre of this.preferentials) {
      //           if (pre.isSelect && pre.type !== 4) {
      //             couponId = 0;
      //             couponPrice = 0;
      //           }
      //         }
      //       }
      //       if (!this.isPres) {
      //         this.couponId = couponId;
      //         this.couponPrice = couponPrice;
      //       }
      //       this.coupons = [...coupons];
      //     } else {
      //       this.couponId = 0;
      //     }
      //   });
      // this.$service.preferential.coupon.userCoupon({ content: postData })
      //   .then((result) => {
      //     // if(!result.$.checkResult(result,true)){return false;}
      //     const coupons = result
      //       .data
      //       .filter(item => !item.coupon.isProductSoldout && item.coupon.isProductInServiceTime)
      //       .sort((a, b) => b.coupon.offsetMoney - a.coupon.offsetMoney);

      //     if (coupons.length > 0) {
      //       let couponIndex = 0;
      //       let couponId = 0;
      //       let couponPrice = 0;
      //       if (this.couponId > 0) {
      //         for (const [index, item] of coupons.entries()) {
      //           if (item.couponId === this.couponId) {
      //             couponIndex = index;
      //             ({ couponId } = item);
      //             couponPrice = item.coupon.offsetMoney;
      //             break;
      //           }
      //         }
      //       } else {
      //         [{ couponId }] = coupons;
      //         couponPrice = coupons[0].coupon.offsetMoney;
      //         if (Object.keys(this.submit.pres).length > 0) {
      //           for (const [index, item] of coupons.entries()) {
      //             if (item.coupon.canUseWithPre === true) {
      //               couponIndex = index;
      //               ({ couponId } = item);
      //               couponPrice = item.coupon.offsetMoney;
      //               break;
      //             }
      //           }
      //         }
      //       }

      //       if (!coupons[couponIndex].coupon.canUseWithPre) {
      //         for (const pre of this.preferentials) {
      //           if (pre.isSelect && pre.type !== 4) {
      //             couponId = 0;
      //             couponPrice = 0;
      //           }
      //         }
      //       }

      //       this.couponId = couponId;
      //       this.couponPrice = couponPrice;
      //       this.coupons = [...coupons];
      //     } else {
      //       this.couponId = 0;
      //     }
      //   });
    },
    // 兑换优惠卡
    // $judgeCardUsable() {
    //   if (this.cardCode.replace(/\s/, '') === '') {
    //     return false;
    //   }
    //   // const self = this;
    //   const postData = {
    //     storeId: this.storeId,
    //     orderType: this.sendType,
    //     code: this.cardCode,
    //     appointmentTime: this.selfGetTime,
    //   };
    //   this.submit.cardCode = '';
    //   this.$service.preferential.isCanUseCardCode({ content: postData })
    //     .then((result) => {
    //       // if(!result.$.checkResult(result,true)){return false;}
    //       this.cardTips = result.msg;
    //       if (result.data.isCanUseCode) {
    //         const { coupon } = result.data;
    //         this.cardTips = this.$i18n.locale === 'zh' ? `正使用优惠卡: ${coupon.name}` : `Using a discount card: ${coupon.name}`;
    //         this.submit.cardCode = coupon.code;
    //         if (coupon.reliefType === 1) { // 减免餐品费
    //           this.cardPreDeliveryPrice = 0;
    //           this.cardPrePrice = coupon.offsetMoney;
    //         } else if (coupon.reliefType === 2) { // 减免配送费
    //           this.cardPrePrice = 0;
    //           this.cardPreDeliveryPrice = coupon.offsetMoney;
    //         }
    //       }
    //       // this.$Modal.info({
    //       //   content: result.msg,
    //       //   onOk () {
    //       //     // 处理相应价格
    //       //   }
    //       // })
    //     });
    // },
    // 兑换优惠券回调
    // $couponConvertCb() {
    //   this.getCoupons();
    // },
    // 兑换优惠券
    // $showConverCoupon() {
    //   this.modal.template = 'convert-coupon';
    //   this.modal.title = 'enterCouponCode';
    //   this.modal.data = {
    //     storeId: this.storeId,
    //     orderType: this.sendType,
    //     selfGetTime: this.selfGetTime,
    //     totalPrice: this.totalPrice,
    //     products: [...this.foods],
    //   };
    //   this.modal.show = true;
    // },
    // 获取用户地址列表
    // $getAddresses() {
    //   const self = this;
    //   this.$service.user.address.getter({})
    //     .then((result) => {
    //       self.addresses.splice(0);
    //       // self.addresses.splice(0);
    //       if (result.data && result.data.length > 0) {
    //         for (const [index, address] of result.data.entries()) {
    //           self.addresses.push(Object.assign(address, { isRange: true }));
    //           self.$isPassAddresses({
    //             address,
    //             index,
    //             length: result.data.length,
    //             callback(i, res) {
    //               if (res.status === 1 && res.data.length > 0) {
    //                 address.isRange = true;
    //                 if (self.submit.longitude == address.longitude && self.submit.latitude === address.latitude) {
    //                   self.currentAddressIndex = index;
    //                 }
    //               } else {
    //                 address.isRange = false;
    //                 if (i === self.currentAddressIndex) {
    //                   self.currentAddressIndex = -1;
    //                   self.sendType == 2 && (self.isPass = false);
    //                 }
    //               }
    //             },
    //           });
    //         }
    //       }
    //     });
    // },
    // 编辑地址操作
    // $editAddress(type) {
    //   this.modal.template = 'address';
    //   if (type === 'add') {
    //     this.modal.type = 'add';
    //     this.modal.data = {};
    //     this.modal.show = true;
    //   } else if (type === 'edit') {
    //     const data = {};
    //     if (this.currentAddressIndex === -1) {
    //       Object.assign(data, {
    //         receiverName: this.submit.name,
    //         receiverPhone: this.submit.phone,
    //         receiverAddress: this.submit.address,
    //         appendReceiverAddress: '',
    //         longitude: this.submit.longitude,
    //         latitude: this.submit.latitude,
    //       });
    //     } else {
    //       Object.assign(data, this.addresses[this.currentAddressIndex]);
    //     }
    //     this.modal.type = 'edit';
    //     this.modal.data = { ...data };
    //     this.modal.show = true;
    //   }
    // },
    // 编辑地址保存成功回调
    // $addressSavedCb(result) {
    //   this.isPass = false;
    //   this.submit.name = result.receiverName;
    //   this.submit.phone = result.receiverPhone;
    //   this.submit.address = result.receiverAddress + (result.appendReceiverAddress || '');
    //   this.submit.longitude = result.longitude;
    //   this.submit.latitude = result.latitude;
    //   this.$getAddresses();
    // },
    // 判断地址是否在门店配送范围
    // $isPassAddresses({ address, index, callback = () => {} }) {
    //   const postData = {
    //     storeId: this.storeId,
    //     coordinate: [address.longitude, address.latitude],
    //   };
    //   this.$service.store.range({ content: postData })
    //     .then((result) => {
    //       callback(index, result);
    //     });
    // },
    // 选择用户地址
    // $selectAddress(index, address) {
    //   if (address.isRange) {
    //     this.currentAddressIndex = index;
    //   }
    // },
    // $close() {
    //   this.modal.show = false;
    //   this.modal.type = '';
    //   this.modal.data = {};
    // },
    // 返回门店页
    backToBooking() {
      // const { sid } = this;
      sessionStorage.removeItem('booking_storage');
      this.$router.push({ name: 'booking-menu', params: { storeId: this.storeId } });
    },
    // 判断时间是否在 时间区间内
    // time1 开始日期
    // time2 结束日期
    interval(time1, time2, now = new Date()) {
      const time = Date.parse(now);
      const date1 = Date.parse(new Date(time1.replace(/-/g, '/')));
      const date2 = Date.parse(new Date(time2.replace(/-/g, '/')));
      // if () {
      //   return true;
      // }
      return date1 <= time && date2 >= time;
    },
    // 进入结算页初始化
    initOrder() {
      const storage = JSON.parse(sessionStorage.getItem('booking_storage'));
      const temptationProducts = JSON.parse(sessionStorage.getItem('booking_storage_temptation'));
      const cartData = JSON.parse(sessionStorage.getItem('booking_cart'));
      if (temptationProducts) {
        this.temptationProducts = temptationProducts;
      }
      if (storage) {
        const self = this;
        for (const key in storage) {
          // if (self.hasOwnProperty(key)) {
          if (Object.prototype.hasOwnProperty.call(self, key)) {
            if (Object.prototype.toString.call(storage[key]) === '[object Object]') {
              self[key] = Object({}, JSON.parse(JSON.stringify({ [key]: storage[key] })));
            } else if (Object.prototype.toString.call(storage[key]) === '[object Array]') {
              self[key] = [...storage[key]];
            } else {
              self[key] = storage[key];
            }
          }
        }
        this.goods = cartData.goods;
        const store = JSON.parse(sessionStorage.getItem('booking_store'));
        this.storeAddress = store.storeAddress;
        this.coordinate = store.coordinate;
        this.waitTime = store.waitTime;
        this.businessTimes = store.businessTimes;

        // let user = Com.Utils.data.L.get(`${___PROJECT}_user`);

        // let location = Com.Utils.data.L.get(`${___PROJECT}_location`);
        // if (location) {
        //   Vue.set(this, 'location', location);

        //   if (location && Object.keys(location).length > 0) {
        //     let {longitude, latitude, district, name} = location;
        //     if (longitude && latitude) {
        //       this.submit.longitude = longitude;
        //       this.submit.latitude = latitude;
        //       this.submit.address = name;
        //       this.submit.name = (user.compellation||user.userName);
        //       this.submit.phone = (user.phone || '');
        //       this.isPass = true;
        //     }
        //   }
        // }
        if (this.businessTimes.findIndex(val => this.interval(`${moment.Format('yyyy-MM-dd', new Date())} ${val.beginTime}`, `${moment.Format('yyyy-MM-dd', new Date())} ${val.endTime}`)) === -1) {
          console.log('service time true');
          this.isServerTime = false;
        }
        const bookingAddressInfo = JSON.parse(sessionStorage.getItem('booking_address_info'));
        if (bookingAddressInfo.userAddress) {
          const { userAddress } = bookingAddressInfo;
          this.submit.name = userAddress.receiverName;
          this.submit.address = userAddress.receiverAddress + (userAddress.appendReceiverAddress ? userAddress.appendReceiverAddress : '');
          this.submit.longitude = userAddress.longitude;
          this.submit.latitude = userAddress.latitude;
          this.submit.phone = userAddress.receiverPhone;
          // this.appointmentTime = store.appointmentTime.map(item => ({
          //   date: item.date,
          //   times: this.$service.order.changeTimes(item.times),
          // }));
          // [{ times: [this.selfGetTime] }] = this.appointmentTime;
        } else if (this.sendType === 2) {
          // 自取
          // 放在isLogin里面赋值
          // const user = this.$service.user.getUser();
          // this.submit.name = (user.info.compellation || user.info.userName);
          // this.submit.phone = (user.info.phone || '');
          this.submit.address = store.storeAddress;
          this.submit.longitude = storage.longitude;
          this.submit.latitude = storage.latitude;
          this.isPass = true;
          // this.takeSelfTime = store.takeSelfTime.map(item => ({
          //   date: item.date,
          //   times: this.$service.order.changeTimes(item.times),
          // }));
          // this.selfGetTime = 'now';
        }
        this.showSelfGetTime();
        if (storage.payTypes.indexOf(1)) {
          self.submit.payType = 1;
        } else if (storage.payTypes.indexOf(2)) {
          self.submit.payType = 2;
        }

        if (storage.invoiceType.length === 1 && storage.invoiceType[0] === 3) {
          self.isEInvoice = true;
          self.submit.isInvoice = true;
          self.submit.invoiceType = 3;
        } else if (storage.invoiceType.length > 0) {
          if (storage.invoiceType.indexOf(2)) {
            self.submit.invoiceType = 2;
          } else if (storage.invoiceType.indexOf(1)) {
            self.submit.invoiceType = 1;
          }
        }

        // 初始化优惠活动
        this.getCanPreferentials()
          .then(() => {
            this.isPres = (Boolean(this.preferentials.length) || Boolean(this.productPre.length)) && !this.isMembers && !this.isCoupons;
            this.showPres = this.isPres;
          });
      } else {
        this.$router.go({ name: 'booking-menu', params: { storeId: this.storeId } });
      }
    },
    // 计算预计送达时间
    getEstimatedTime() {
      return new Date(new Date().getTime() + (this.waitTime * 60 * 1000));
    },
    // 提交订单
    submitOrder() {
      const postData = {
        storeId: this.storeId,
        menuId: this.menuId,
        type: this.sendType,
        selfGetTime: this.selfGetTime,
        name: this.submit.name,
        phone: this.submit.phone,
        peopleNum: this.peopleNum,
        payType: this.submit.payType,
        isInvoice: this.submit.isInvoice,
        userNote: this.submit.userNote,
        pres: { ...this.submit.pres },
      };
      if (postData.type === 1 && postData.selfGetTime !== 'now' && JSON.parse(sessionStorage.getItem('booking_store')).businessType.indexOf(4) > -1) {
        // 是外卖类型且送达时间不是立即送达且业务类型支持外卖预约
        postData.type = 4;
      }
      if (postData.selfGetTime === 'now') {
        postData.selfGetTime = moment.Format('yyyy-MM-dd HH:mm:ss', this.estimatedTime);
      }
      if (!this.validName()) {
        this.$Modal.info({ content: this.$t('tip.input.name') });
        return false;
      }
      if (!this.validPhone()) {
        this.$Modal.info({ content: this.$t('user.enterPhone') });
        return false;
      }
      if (!/^\d{11}$/.test(this.submit.phone)) {
        this.$Modal.info({ content: this.$t('tip.phoneFormat.mobile') });
        return false;
      }
      // 强制选择餐具提示
      if (this.tablewareOptions && !this.peopleNum) {
        this.$Modal.info({ content: this.$t('tip.pleaseChooseCutlery') });
        return false;
      }
      if (this.sendType === 2) {
        Object.assign(postData, {
          longitude: this.coordinate[0],
          latitude: this.coordinate[1],
          address: this.storeAddress,
        });
      } else {
        if (!this.submit.longitude || !this.submit.latitude) {
          this.$Modal.info({ content: this.$t('tip.input.address2') });
          return false;
        }
        Object.assign(postData, {
          longitude: this.submit.longitude,
          latitude: this.submit.latitude,
          address: this.submit.address,
        });
      }
      if (this.submit.isInvoice) {
        if (!this.validInvoiceDesc() || !this.validInvoiceType() || !this.validTaxNo()) {
          return false;
        }
        const invoiceData = {
          invoiceType: this.submit.invoiceType,
          invoiceDesc: this.submit.invoiceDesc,
          taxNo: this.submit.taxNo,
        };
        if (this.submit.invoiceType !== 2) {
          // 非机打发票
          delete invoiceData.invoiceDesc;
          delete invoiceData.taxNo;
        }
        Object.assign(postData, invoiceData);
      }
      // if (this.sendType === 1
      //   && this.businessTimes.findIndex(val => !this.interval(`${moment.Format('yyyy-MM-dd', new Date())} ${val.beginTime}`, `${moment.Format('yyyy-MM-dd', new Date())} ${val.endTime}`, this.selfGetTime)) > -1
      //   && JSON.parse(sessionStorage.getItem('booking_store')).businessType.indexOf(4) > -1) {
      //   console.log('预约单');
      //   postData.type = 4;
      // }

      if (!this.isLoading) {
        this.isLoading = true;

        if (this.couponId > 0) {
          Object.assign(postData, { couponId: this.couponId });
        }
        if (this.submit.cardCode !== '') {
          Object.assign(postData, { cardCode: this.submit.cardCode });
        }

        if (this.isMembers) {
          postData.memberPreferentials = this.memberPreferentials;
        }

        if (this.couponId) {
          // 核销优惠券
          const couponData = this.coupons.find(val => val.cid === this.couponId);
          postData.memberPreferentials = [{
            type: 7,
            childType: 3,
            prePrice: this.couponPrice > 0 ? -(this.couponPrice) : this.couponPrice,
            content: couponData.name,
            pid: couponData.fdCouponCode, // fdCouponCode
          }];
        }

        // 处理餐品数据
        const products = [];
        for (const food of this.foods) {
          const product = {
            pid: food.pid,
            typeId: food.typeId,
            num: food.num,
          };
          if (food.isRequirement) {
            Object.assign(product, { listRequirements: this.$service.menu.filterRequirement(food.listRequirements) });
          }
          if (food.type === 2) {
            Object.assign(product, { groups: food.groups });
          }
          products.push(product);
        }

        // 处理加价购
        for (const extra of this.extraProducts) {
          if (extra.count > 0) {
            if (!Object.prototype.hasOwnProperty.call(postData.pres, extra.preId)) {
            // if (!postData.pres.hasOwnProperty(extra.preId)) {
              Object.assign(postData.pres, {
                [extra.preId]: {
                  [extra.index]: extra.count,
                },
              });
            } else {
              postData.pres[extra.preId][extra.index] = extra.count;
            }
          }
        }

        Object.assign(postData, {
          products: [...products],
          randomCode: md5(Date.parse(new Date()) + parseInt(Math.random() * (10000 - 1 + 1) + 1, 10)),
        });
        this.$service.order.push({ content: postData })
          .then((result) => {
            if (result.status === 5) {
              let content = `
                <div>${result.msg}</div>
                <div>===============================</div>
                <div>
              `;
              for (const item of result.data) {
                content += `<span>${item.name}</span>`;
              }
              content += '<div>';
              this.$Modal.info({
                content,
              });
              // this.isLoading = false;
              return false;
            }
            // if (!result.$.checkResult(result,true)) {this.isLoading=false; return false;}
            // Com.Utils.data.L.remove(`${___PROJECT}_location`);
            // sessionStorage.removeItem('booking_cart');
            // sessionStorage.removeItem('booking_store');
            // sessionStorage.removeItem('booking_storage');
            // sessionStorage.removeItem('booking_storage_temptation');
            // sessionStorage.removeItem('booking_address_info');
            this.clearCaches();
            this.orderId = result.data;
            return result;
          })
          .then((result) => {
            if (result) {
              return this.$service.preferential.coupon.orderCoupon({ content: { orderId: result.data } });
            }
            return false;
          })
          .then((res) => {
            // if (!res.$.checkResult(res, true)) {
            //   this.isLoading = false;
            //   return false;
            // }
            if (!res) {
              return false;
            }
            if (res.data) {
              this.orderCoupon = JSON.parse(JSON.stringify(res.data));
              this.isShowOrderCoupon = true;
            } else {
              this.handleOrder();
            }
            return true;
          })
          .catch((err) => {
            if (err.msg) {
              this.$Modal.info({ content: err.msg });
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
      return true;
    },
    handleOrder() {
      this.isShowOrderCoupon = false;
      if (this.submit.payType === 2) {
        this.$router.push({ name: 'paying', params: { orderId: this.orderId } });
      } else {
        this.$router.push({ path: '/user-center/order' });
        // const href = `${window.location.origin}/userCenter.html${BASEKEY}#/orders`;
        // window.location.href = href;
      }
    },
    // $showGroup(good) {
    //   this.isShowGroup = true;
    //   this.currentProductGroupSet.splice(0);

    //   this.currentProductGroupSet = PRODUCTS.groupSet.format_0(good.groups).concat([]);
    //   this.currentProduct = good;
    // },
    // $hideGroup() {
    //   this.isShowGroup = false;
    // },
    // $showRequiremt(i) {
    //   if (this.isShowRequiremt[i] === undefined) {
    //     const arr = {
    //       [i]: false,
    //     };

    //     this.$set(this, 'isShowRequiremt', arr);
    //   }
    //   this.isShowRequiremt[i] = !this.isShowRequiremt[i];
    // },
    // 针对套餐
    // $saveGroup(groups) {
    //   this.food.groups = [...groups];
    //   this.ADD_TO_CART(this.food, this.index);
    // },
  },
};
</script>
<style lang="sass" scoped>
@import '../../assets/css/mixins'

.select-checked
  background: url('../../assets/image/icon/icon-li-bg.png') no-repeat right top
  position: absolute
  display: inline-block
  top: 0
  right: 0
  width: 36px
  height: 37px
.order-wrap
  height: auto
  color: #494949
  position: relative
  &-min
    min-height: 783px
  .order-content
    display: flex
    justify-content: space-between
    height: 100%
    min-height: 783px
  .order-products
    height: 100%
    min-height: 783px
    // min-height: 800px
    .order-foods-box
      min-height: 783px
      width: 633px
      padding: 33px 0 20px 33px
      background: #f5f5f5
      position: relative
      margin-bottom: 12px
      overflow-y: auto
      // height: 422px
      .title
        font-size: 14px
        overflow: hidden
        color: #0e9675
        margin-bottom: 42px
        .flag
          font-size: 22px
          line-height: 2
          font-weight: 400
          font-style: normal
          padding-right: 12px
        span
          font-size: 13px
          float: right
          line-height: 1.2
        // .cd-button
        //   position: absolute
        //   top: 16px
        //   right: 14px
        //   min-width: 120px
        //   color: #fff
        //   padding: 7px 3px
        //   &:before
        //     content: ''
        //     display: inline-block
        //     vertical-align: -6px
        //     width: 28px
        //     height: 23px
        //     // background: url('~static/images/candao-web-wxy/icon-back2.png') no-repeat left center
      .order-pres
        margin: 15px 0 18px 0
        h3
          margin-left: -33px
          color: #101111
          font-weight: bold
          padding-left: 18px
          background-color: #ccc
          line-height: 33px
          font-size: 14px
          font-weight: 400
          .iview-checkbox
            color: #7a7a7a
          .order-pres-close
            float: right
            color: #ad0f14
            margin-right: 16px
            text-decoration: underline
            cursor: pointer
        .promotions-box
          .promotion-item
            margin-bottom: 17px
            .promotion-name
              padding: 7px 0
              border-bottom: 1px solid #e1e1e1
              margin: 5px 0
              margin-left: -25px
              .icon-radio, span
                display: inline-block
                vertical-align: top
              .icon-radio
                display: inline-block
                width: 15px
                height: 15px
                // background: url('~static/images/candao-web-wxy/icon-radio-0.png') no-repeat center
                &.actived
                  // background: url('~static/images/candao-web-wxy/icon-radio-1.png') no-repeat center
              span
                margin-left: 33px
                font-weight: 700
                color: #0f9675
                display: inline-block
                white-space: nowrap
                overflow: hidden
                text-overflow: ellipsis
                width: 530px
                work-break: break-all
            .product-info-list
              display: flex
              flex-wrap: wrap
              .product-info
                position: relative
                background-color: #f1f1f1
                width: 183px
                margin: 0 6.5px 8px 6.5px
                border: 1px solid #e1e1e1
                &.group-select-checked
                  border-color: #0f9675
                img
                  width: 100%
                  height: 122px
                &-name
                  height: 33px
                  font-size: 14px
                  color: #0f9675
                  padding: 0 7px
                  >span
                    line-height: 35px
                    display: inline-block
                    min-width: 140px
                    max-width: 140px
                    overflow: hidden
                    white-space: nowrap
                    text-overflow: ellipsis
                &-icon
                  float: right
                  font-size: 14px
                  margin: auto 5px
                  color: rgb(67, 67, 67)
                  line-height: 35px
                .product-price
                  height: 32px
                  .product-price-noreq
                    clear: both
                    height: 32px
                    line-height: 32px
                    >span
                      color: #ad0f14
                      font-size: 14px
                      font-weight: 700
                      s
                        color: #999
                    .product-price-num
                      display: inline-block
                      float: right
                      span
                        display: inline-block
                        border: 1px solid #d6d3ce
                        width: 32px
                        height: 20px
                        line-height: 18px
                        text-align: center
                        font-size: 14px
                        font-weight: 700
                        color: #282828
                        vertical-align: middle
                      >i
                        font-size: 22px
                        color: #449377
            .promotion__select
              width: 200px
              height: 32px
              line-height: 32px
              margin-top: 15px
            .promotion__selects
              width: 504px
              height: 96px
              overflow-y: auto
              padding: 12px 0px
              margin: 22px 0px
              border: 1px solid #dedede
              li
                height: 46px
                line-height: 46px
                padding: 0px 12px
                border-bottom: 1px solid #f1f1f1
              .icon-check, span
                display: inline-block
                vertical-align: middle
              .icon-check
                width: 18px
                height: 18px
                padding-right: 8px
                // background: url('~static/images/candao-web-wxy/icon-check.png') no-repeat center
                &.actived
                  // background: url('~static/images/candao-web-wxy/icon-checked.png') no-repeat center
      .coupons-box
        margin: 15px 0 18px 0
        // .coupons-select-box
        //   display: inline-block
        //   vertical-align: top
        //   line-height: 36px
        .flag
          font-size: 14px
          font-weight: bold
          font-style: normal
          color: #333
        h3
          margin-left: -33px
          color: #101111
          font-weight: bold
          padding-left: 18px
          background-color: #ccc
          line-height: 33px
          font-size: 14px
          font-weight: 400
          .iview-checkbox
            color: #7a7a7a
        .coupons-select-box
          padding: 10px 0 10px 10px
          .cd-input
            width: 198px
            vertical-align: middle
          // .cd-button
          //   margin-left: 12px
          //   line-height: 18px
        .coupons__select
          width: 155px
          height: 32px
          cursor: pointer
          color: #7a7a7a
          border-color: #dedede
        .coupon-change
          color: #7a7a7a
      .order-fees
        overflow: hidden
        margin-bottom: 24px
        div
          border-bottom: 1px solid #cacaca
          height: 40px
          margin-right: 30px
        p
          font-size: 14px
          display: flex
          justify-content: space-between
          em, span
            display: inline-block
            vertical-align: top
            line-height: 36px
          em
            font-size: 14px
            font-style: normal
            color: #7a7a7a
            &.delete
              padding-right: 60px
              text-decoration: line-through
          span
            font-weight: 700
            color: #333
          &.total-price__p
            text-align: right
            .off-pre-price
              color: #999
              padding-right: 60px
      .to-next
        text-align: center
        a
          color: #0f9675
        .cd-btn
          min-width: 118px
          padding: 6px 0
          margin-left: 44px
      .orders-tab
        font-size: 14px
        border-bottom: 1px solid #cacaca
        line-height: 25px
        color: #7a7a7a
        margin: 0 38px 8px 0
        display: flex
      .order-list
        min-height: 100px
        .tb-orders-el
          width: 100%
          color: #7a7a7a
          .group-info
            width: 160px
            display: table-cell
            vertical-align: inherit
          td
            font-size: 14px
            line-height: 16px
            text-align: center
            padding: 14px 0px
            .good-requirement
              margin-top: 5px
              font-size: 12px
              color: #959595
              white-space: pre-line
            &.reqs__tb
              text-align: left
            &.text-left
              text-align: left
            &.btn-right
              text-align: right
              button
                background-color: #e50013
    .group-detail-box
      position: absolute
      top: 0px
      left: 0px
      width: 510px
      height: 418px
      overflow-y: auto
      padding-right: 10px
      background-color: #fff
      h3
        text-align: right
        .close
          display: inline-block
          width: 21px
          height: 21px
          font-size: 21px
          font-weight: 700
          line-height: 1
          color: #fc8b00
          text-shadow: 0 1px 0 #fff
          text-align: right
          margin: 8px 0 18px 0
          font-style: normal
          cursor: pointer
      .group-detail
        padding: 0 18px
        h4
          color: #494949
          font-size: 14px
          line-height: 28px
          margin-top: 18px
        .group-item
          line-height: 28px
          color: #5b5b5b
          .item-name
            float: left
            display: block
            max-width: 400px
          .item-num
            float: right
          .normal
            font-style: normal
      &:first-child
        .group-detail
          margin-top: 0px
  .add-product
    background: #f5f5f5
    width: 292px
    padding: 0 0 66px 0
    text-align: center
    height: 100%
    h2
      color: #0e9675
      font-size: 22px
      margin: 33px 0 33px 28px
      text-align: left
    .menu-small-product
      display: flex
      flex-wrap: wrap
      margin-bottom: 8px
      justify-content: center
      >li
        position: relative
        background-color: #fff
        width: 236px
        margin: 8px 7px
        border: 1px solid #e1e1e1
        &.product-select-checked
          border-color: #0f9675
        .select-checked
          background: url('../../assets/image/icon/icon-li-bg.png') no-repeat right top
          position: absolute
          display: inline-block
          top: 0
          right: 0
          width: 36px
          height: 37px
        img
          width: 234px
          height: 160px
        .product-info
          height: auto
          background-color: #f1f1f1
          padding: 9px 7px 0 7px
          clear: both
          &-name
            line-height: 35px
            font-size: 15px
            color: #0f9675
            >span
              display: inline-block
              min-width: 190px
              max-width: 190px
              overflow: hidden
              white-space: nowrap
              text-overflow: ellipsis
          &-icon
            float: right
            font-size: 16px
            margin: auto 5px
            color: rgb(67, 67, 67)
            line-height: 35px
        .product-price
          height: 100%
          .product-price-noreq
            clear: both
            height: 44px
            >span
              color: #ad0f14
              font-size: 16px
              font-weight: 700
              s
                color: #999
            >i
              font-size: 28px
              color: #449377
              float: right
  .order-supplement
    width: 100%
    background: #f5f5f5
    padding-bottom: 20px
    >h3
      height: 32px
      font-size: 22px
      padding: 10px 0 60px 30px
      color: #0e9675
    .user-address-info
      margin-bottom: 13px
      margin-left: 55px
      .address-info-item
        line-height: 34px
        font-size: 14px
        .info-item-change
          margin-left: 16px
          cursor: pointer
          color: #0e9675
        .select-time
          width: 165px
        .select-time-now
          font-size: 14px
          margin-left: 16px
          cursor: pointer
          color: #0e9675
    .other-info-box
      margin-top: 15px
      margin-bottom: 23px
      .iview-input
        width: 275px
        background-color: #fff
      .box-label, > div
        display: inline-block
        vertical-align: top
      .box-label
        color: #7a7a7a
        font-size: 14px
        width: 86px
      .types__selects
        float: right
        .type-select__btn
          display: inline-block
          min-width: 86px
          padding: 0 10px
          height: 25px
          line-height: 25px
          text-align: center
          margin-right: 18px
          color: #fff
          border-radius: 30px
          background: #7a7a7a
          border: none
          &.actived, &:hover
            background: #016636
      .cd-input
        width: 284px
      .cutlery__select
        width: 165px
    .delivery-info-box
      margin-left: 55px
      border-top: 1px solid #DCDCDC
      .title-box
        overflow: hidden
        margin-bottom: 7px
        > span
          float: right
          cursor: pointer
      .title-h
        float: left
        color: #016636
        font-size: 16px
        font-weight: bold
        line-height: 1.1
      .add-address__btn
        color: #e60012
      // .address-info-wrap
      //   border: 1px dashed #babbbb
      //   padding-top: 38px
      //   padding: 0 10px
      //   border-radius: 6px
      // .address-located
      //   margin-top: 38px
      //   min-height: 114px
      //   .address-info-box
      //     border: 1px solid #dedede
      //     padding: 18px 14px
      //     min-height: 34px
      //     max-height: 54px
      //     position: relative
      //     .address-info
      //       .user-name,
      //       .user-phone
      //         display: inline-block
      //         margin-right: 30px
      //       a
      //         color: #e60012
      //       p
      //         margin-top: 10px
      //       &.err-address
      //         // background: url('~static/images/candao-web-wxy/err-addr.png') no-repeat 370px 0px
      //       &.err-address-hk
      //         // background: url('~static/images/candao-web-wxy/err-addr-hk.png') no-repeat 370px 0px
      //       &.err-address-en
      //         // background: url('~static/images/candao-web-wxy/err-addr-en.png') no-repeat 370px 0px
      //     .edit-address__btn
      //       position: absolute
      //       top: 5px
      //       right: 14px
      //       font-size: 14px
      //       display: none
      //     &:hover
      //       border-color: #016636
      //       .edit-address__btn
      //         color: #e60012
      //         display: block
      // .address-unlocated
      //   width: 476px
      //   border: 1px solid #dedede
      //   padding: 18px 14px
      //   min-height: 34px
      //   max-height: 54px
      //   cursor: pointer
      //   .create__btn
      //     display: block
      //     text-align: center
      //     font-size: 14px
      //     &:before
      //       content: ''
      //       // background: url('~static/images/candao-web-wxy/icon-add.png') no-repeat left center
      //       display: inline-block
      //       width: 30px
      //       height: 30px
      //       vertical-align: middle
      //       margin-right: 12px
      //   &:hover
      //     border-color: #fd8f0e
      // .address-list-box
      //   height: 96px
      //   overflow-y: auto
      //   padding: 12px 0px
      //   margin: 12px 0px 14px
      //   border: 1px solid #dedede
      //   .address-user__dl
      //     height: 46px
      //     line-height: 46px
      //     padding: 0px 12px
      //     cursor: pointer
      //     position: relative
      //     &.err-address
      //       cursor: no-drop
      //       // background: url('~static/images/candao-web-wxy/err-addr.png') no-repeat 370px 4px
      //     &.err-address-hk
      //       cursor: no-drop
      //       // background: url('~static/images/candao-web-wxy/err-addr-hk.png') no-repeat 370px 0px
      //     &.err-address-en
      //       cursor: no-drop
      //       // background: url('~static/images/candao-web-wxy/err-addr-en.png') no-repeat 370px 4px
      //     &.actived
      //       background-color: #faf9f9
      //       .address-name
      //         // background: url('~static/images/candao-web-wxy/icon-checked.png') no-repeat left center
      //     dt, dd
      //       display: inline-block
      //       vertical-align: top
      //       @include ellipsis
      //     .address-name
      //       width: 58px
      //       min-width: 58px
      //       max-width: 92px
      //       padding-left: 30px
      //       font-weight: normal
      //       // background: url('~static/images/candao-web-wxy/icon-check.png') no-repeat left center
      //     .address-phone
      //       width: 92px
      //       min-width: 92px
      //       max-width: 122px
      //     .address-txt
      //       width: 240px
      // .take-self-box
      //   color: #494949
      //   .cd-input
      //     margin: 0px 18px
      //     &.error
      //       border: 1px solid #f99b1d
      //   .name__input
      //     width: 74px
      //   .phone__input
      //     width: 131px
      //   .tips
      //     color: #ff8a00
      //     line-height: 24px
      .paytype-wrap
        margin: 15px 0 18px 0
        border-radius: 4px
        padding: 10px
        .jiaobanbisa_paytip
          margin: 20px 0
        .types__selects
          position: relative
          top: 3px
      .invoice-wrap
        margin: 15px 0 18px 0
        border: 1px dashed #babbbb
        border-radius: 4px
        overflow: hidden
        display: block
        font-weight: bold
        padding-left: 10px
        line-height: 30px
        background: #e5e6e6
      .cutlery-box
          .box-label
            line-height: 35px
          .type-select__btn
            vertical-align: middle
            margin-left: 20px
      .paytype-select
        // .pay-type__btn
        //   display: inline-block
        //   min-width: 88px
        //   height: 30px
        //   line-height: 30px
        //   text-align: center
        //   padding: 0px 10px
        //   margin-right: 18px
        //   border: 1px solid #dedede
        //   color: #7a7a7a
        //   @include border-radius(5px)
        //   &.actived, &:hover
        //     border-color: #ff8a00
        //     color: #ff8a00
        .select-type-radio
          margin: 0 60px 0 4px
        .cash-coupon-box
          margin-top: 20px
          .cash-coupon-container
            display: inline-block
            vertical-align: top
            margin-left: 10px
      .invoice-select-box
        .e-invoice-tips
          line-height: 30px
      /* 叫板披萨 餐具数量 样式 */
      .jiaobanbisa_standard
        display: inline-block
        .control-btn
          height: 34px
          width: 34px
          line-height: 31px
          font-size: 20px
          border: 0px
          cursor: pointer
          font-weight: bold
          vertical-align: middle
          background-color: #ff8b01
          color: #fff
          @include border-radius(2px)
        .control-count
          cursor: default
          display: inline-block
          vertical-align: middle
          height: 32px
          line-height: 32px
          margin: 0 4px
          text-align: center
          width: 34px
          padding: 0
          color: #ff8a00
          background-color: #f4f3f3
          border: 1px solid #e1e1e1
      .notice-wrap
        margin: 15px 0 18px 0
        overflow: hidden
        .title
          display: inline-block
          width: 86px
          padding-left: 10px
          color: #7a7a7a
          font-size: 14px
        .user-note__textarea
          width: 417px
          height: 92px
          padding: 10px 15px 10px 15px
          border: 1px solid #dedede
      .submit-btn-box
        margin:
          left: 155px
          top: 15px
          bottom: 15px
        a
          color: #0f9675
        .cd-btn
          min-width: 118px
          padding: 6px 0
          margin-left: 44px
.order-coupon-wrap,
.order-coupon-box
  top: 0
  left: 0
  bottom: 0
.order-coupon-wrap
  position: fixed
  z-index: 200
  background-color: rgba(#000, .4)
.order-coupon-box
  position: absolute
  margin: auto
  width: 384px
  height: 424px
  // background: url('~static/images/candao-web-wxy/scoupon.png') no-repeat center
  .contain
    position: relative
    top: 68px
    left: 50%
    margin-left: -200px
    width: 380px
    .main
      p
        width: 320px
        height: 80px
        // background: url('~static/images/candao-web-wxy/quan_bg.png') no-repeat center
        margin-bottom: 10px
        a
          display: inline-block
      p:last-child
        margin-bottom: 0

  .coupon-title
    position: relative
    top: 54px
    text-align: center
    color: #fff
    font-size: 15px
    max-width: 228px
    min-height: 22px
    left: 50%
    margin-left: -114px
    overflow: hidden
    text-overflow: ellipsis
  .coupon-name
    position: relative
    top: 16px
    left: 20px
    font-size: 15px
    width: 219px
    @include ellipsis
  .coupon-minMoney
    position: relative
    top: 16px
    left: 20px
    font-size: 14px
    color: #c6c6c6
    width: 219px
    @include ellipsis
  .coupon-offsetMoney
    position: relative
    top: 0
    left: 36px
    color: #dd4646
    font-size: 14px
    width: 54px
    @include ellipsis
  // .cd-button
  //   position: relative
  //   top: 144px
  //   left: 50%
  //   margin-left: -46px
.invoice-input
    width: 275px
</style>
